import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import {
  updateProduct,
  updateProductInventory,
  updateTransaction,
  updateTransactionOrderStatus,
  getSingleProduct,
  getSingleOrder,
} from "../../firebase/firebase.utils";
import FullPageLoader from "./fullPageLoder.js";
import {
  getOrdersListRedux,
  updateOrderRedux,
  uploadCashInRedux,
  uploadTransactionRedux,
  updateSingleProductRedux,
  uploadExpenseRedux,
  bulkUpdateOrderStatusRedux,
} from "../../actions/index";
import {
  firestore,
  sumOrdersList,
  syncNewOrdersToList,
  countCollection,
  buildOrderSummary,
} from "../../firebase/firebase.utils";
import { Search } from "react-feather";
import { sendNotifications } from "../../firebase/fcmRestApi";
import SteadFast from "./steadFast.png";
import Pathao from "./pathao.png";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import loader from "sass-loader";
import ReactToPrint from "react-to-print";
import logo from "./zapai2.png";
import Barcode from "react-barcode";
import "./new.css";
import { notifyWarning, notifyError } from "../../utils/notify";
import { confirmDialog } from "../common/ConfirmDialog";
// steadFast api credential
const api_key = "dxglvephxsih8ownxsuap8apiokfxcqm";
const secret_key = "jz2yogdjkxza8gguqc7of4fr";
const base_url = "https://portal.packzy.com/api/v1";

const orderCache = {};
export class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      singleLot: null,
      expenseObj: null,
      loader: false,
      loader2: false,
      type: "upload",
      checkedValues: [],
      checkedValues2: [],
      id: "",
      name: "",
      quantity: "",
      amount: "",
      description: "",
      searchFor: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      type: "",
      customer: "",
      customerUid: "",
      cursor: -1,
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
      loader: false,
      method: "",
      amount: 0,
      paymentStatus: "",
      transactionId: "",
      cancelNote: "",
      weight: "",
      cityList: [],
      areaList: [],
      loader3: false,
      courierCharge: "",
      loading4: false,
      loading5: false,
      fraudModalOpen: false,
      fraudCheckLoading: false,
      fraudData: null,
      selectedOrderIds: [],
      bulkLoading: false,
      dateFilter: "last-30",
      customStartDate: "",
      customEndDate: "",
      aggStats: null,
      aggLoading: false,
      migrating: false,
      migratedCount: 0,
      migrationDone: false,
      countLoading: false,
      collectionCounts: null,
      recalculatingStats: false,
      recalculatedCount: 0,
      recalculateStatsDone: false,
    };
  }

  getDateRange = (filter) => {
    const now = Date.now();
    const DAY = 86400000;
    if (filter === "today") return { startTs: now - DAY, endTs: now };
    if (filter === "last-30") return { startTs: now - 30 * DAY, endTs: now };
    if (filter === "last-6-months")
      return { startTs: now - 180 * DAY, endTs: now };
    return null;
  };

  getCurrentDateRange = () => {
    const { dateFilter, customStartDate, customEndDate } = this.state;
    if (dateFilter === "custom") {
      const startTs = customStartDate
        ? new Date(customStartDate).setHours(0, 0, 0, 0)
        : null;
      const endTs = customEndDate
        ? new Date(customEndDate).setHours(23, 59, 59, 999)
        : null;
      return { startTs, endTs };
    }
    return this.getDateRange(dateFilter);
  };

  fetchAggStats = async (orderStatus, startTs, endTs) => {
    this.setState({ aggLoading: true });
    try {
      const stats = await sumOrdersList(startTs, endTs, orderStatus);
      this.setState({ aggStats: stats });
    } catch (e) {
      console.error("sumOrdersList failed", e);
    }
    this.setState({ aggLoading: false });
  };

  handleMigrateOrders = async () => {
    if (this.state.migrating) return;
    if (
      !(await confirmDialog(
        "This will sync new orders to ordersList and update summaries. Continue?",
        { danger: false },
      ))
    )
      return;
    this.setState({ migrating: true, migratedCount: 0, migrationDone: false });
    try {
      const total = await syncNewOrdersToList((count) => {
        this.setState({ migratedCount: count });
      });
      this.setState({ migrationDone: true, migratedCount: total });
      toast.success(
        total > 0
          ? `Done — ${total} orders synced to ordersList.`
          : "Already in sync — nothing to migrate.",
      );
    } catch (e) {
      toast.error("Migration failed: " + e.message);
    } finally {
      this.setState({ migrating: false });
    }
  };

  // Fixes drift between the per-status stat tiles (a running counter that
  // was getting silently inflated on every edit to an order that didn't
  // change status — see buildSummaryDelta) and the real orderStatus counts,
  // by fully rebuilding summaries/orderStatsByStatus from a fresh scan of
  // ordersList.
  handleRecalculateOrderStats = async () => {
    if (this.state.recalculatingStats) return;
    if (
      !(await confirmDialog(
        "This will rebuild the order status counters from scratch by rescanning every order. Continue?",
        { danger: false },
      ))
    )
      return;
    this.setState({
      recalculatingStats: true,
      recalculatedCount: 0,
      recalculateStatsDone: false,
    });
    try {
      const total = await buildOrderSummary((count) => {
        this.setState({ recalculatedCount: count });
      });
      this.setState({ recalculateStatsDone: true, recalculatedCount: total });
      toast.success(`Done — recalculated stats from ${total} orders.`);
      const { orderStatus } = this.props.match.params;
      const range = this.getCurrentDateRange();
      this.fetchAggStats(orderStatus, range?.startTs, range?.endTs);
    } catch (e) {
      toast.error("Recalculating stats failed: " + e.message);
    } finally {
      this.setState({ recalculatingStats: false });
    }
  };

  handleCheckCounts = async () => {
    this.setState({ countLoading: true, collectionCounts: null });
    try {
      const [orders, ordersList] = await Promise.all([
        countCollection("orders"),
        countCollection("ordersList"),
      ]);
      this.setState({ collectionCounts: { orders, ordersList } });
    } catch (e) {
      toast.error("Count failed: " + e.message);
    }
    this.setState({ countLoading: false });
  };

  setDateFilter = async (filter) => {
    this.setState({ dateFilter: filter, loading4: true });
    const range = this.getDateRange(filter);
    const { orderStatus } = this.props.match.params;
    await Promise.all([
      this.props.getOrdersListRedux(
        "All Orders",
        null,
        range?.startTs,
        range?.endTs,
      ),
      this.fetchAggStats(orderStatus, range?.startTs, range?.endTs),
    ]);
    this.setState({ loading4: false });
  };

  applyCustomRange = async () => {
    const { customStartDate, customEndDate } = this.state;
    if (!customStartDate || !customEndDate) return;
    this.setState({ dateFilter: "custom", loading4: true });
    const startTs = new Date(customStartDate).setHours(0, 0, 0, 0);
    const endTs = new Date(customEndDate).setHours(23, 59, 59, 999);
    const { orderStatus } = this.props.match.params;
    await Promise.all([
      this.props.getOrdersListRedux("All Orders", null, startTs, endTs),
      this.fetchAggStats(orderStatus, startTs, endTs),
    ]);
    this.setState({ loading4: false });
  };

  componentDidMount = async () => {
    window.addEventListener("scroll", this.handleScroll);

    this.setState({ loading4: true });
    const { orderStatus } = this.props.match.params;
    const { getOrdersListRedux } = this.props;

    if (orderStatus === "All Orders") {
      const range = this.getDateRange("last-30");
      await Promise.all([
        getOrdersListRedux("All Orders", null, range.startTs, range.endTs),
        this.fetchAggStats("All Orders", range.startTs, range.endTs),
      ]);
    } else if (orderStatus === "Processing") {
      await Promise.all([
        getOrdersListRedux("Processing", null),
        this.fetchAggStats("Processing", null, null),
      ]);
    } else if (orderStatus === "Confirmed") {
      await Promise.all([
        getOrdersListRedux("Confirmed", null),
        this.fetchAggStats("Confirmed", null, null),
      ]);
    } else if (orderStatus === "Packing") {
      await Promise.all([
        getOrdersListRedux("Packing", null),
        this.fetchAggStats("Packing", null, null),
      ]);
    } else if (orderStatus === "On the way") {
      await Promise.all([
        getOrdersListRedux("On the way", null),
        this.fetchAggStats("On the way", null, null),
      ]);
    } else if (orderStatus === "Delivered") {
      await Promise.all([
        getOrdersListRedux("Delivered", null),
        this.fetchAggStats("Delivered", null, null),
      ]);
    } else if (orderStatus === "Partial Delivered") {
      await Promise.all([
        getOrdersListRedux("Partial Delivered", null),
        this.fetchAggStats("Partial Delivered", null, null),
      ]);
    } else if (orderStatus === "Cancelled") {
      await Promise.all([
        getOrdersListRedux("Cancelled", null),
        this.fetchAggStats("Cancelled", null, null),
      ]);
    } else {
      await Promise.all([
        getOrdersListRedux(orderStatus, null),
        this.fetchAggStats(orderStatus, null, null),
      ]);
    }

    this.setState({ loading4: false });
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = async () => {
    const { loading5 } = this.state;
    const { hasMore, lastVisible } = this.props;

    // Stop if already loading or no more data
    if (loading5 || !hasMore) return;

    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.documentElement.scrollHeight;

    if (scrollTop < 100) return;
    if (scrollTop + windowHeight >= fullHeight - 100) {
      // Near the bottom
      this.setState({ loading5: true });

      const { orderStatus } = this.props.match.params;
      const { getOrdersListRedux } = this.props;
      console.log("calling get all orders from client");
      const dateRange =
        orderStatus === "All Orders" ? this.getCurrentDateRange() : {};
      await getOrdersListRedux(
        orderStatus,
        lastVisible,
        dateRange?.startTs,
        dateRange?.endTs,
      );

      this.setState({ loading5: false });
    }
  };

  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    const { orderStatus } = this.props.match.params;
    const orderStatus2 = nextProps.match.params.orderStatus;
    if (orderStatus !== orderStatus2) {
      this.setState({ loading4: true });
      const { getOrdersListRedux } = this.props;

      if (orderStatus2 === "All Orders") {
        const range = this.getDateRange("last-30");
        this.setState({
          dateFilter: "last-30",
          customStartDate: "",
          customEndDate: "",
        });
        await Promise.all([
          getOrdersListRedux("All Orders", null, range.startTs, range.endTs),
          this.fetchAggStats("All Orders", range.startTs, range.endTs),
        ]);
      } else if (orderStatus2 === "Processing") {
        await Promise.all([
          getOrdersListRedux("Processing", null),
          this.fetchAggStats("Processing", null, null),
        ]);
      } else if (orderStatus2 === "Confirmed") {
        await Promise.all([
          getOrdersListRedux("Confirmed", null),
          this.fetchAggStats("Confirmed", null, null),
        ]);
      } else if (orderStatus2 === "Packing") {
        await Promise.all([
          getOrdersListRedux("Packing", null),
          this.fetchAggStats("Packing", null, null),
        ]);
      } else if (orderStatus2 === "On the way") {
        await Promise.all([
          getOrdersListRedux("On the way", null),
          this.fetchAggStats("On the way", null, null),
        ]);
      } else if (orderStatus2 === "Delivered") {
        await Promise.all([
          getOrdersListRedux("Delivered", null),
          this.fetchAggStats("Delivered", null, null),
        ]);
      } else if (orderStatus2 === "Partial Delivered") {
        await Promise.all([
          getOrdersListRedux("Partial Delivered", null),
          this.fetchAggStats("Partial Delivered", null, null),
        ]);
      } else if (orderStatus2 === "Cancelled") {
        await Promise.all([
          getOrdersListRedux("Cancelled", null),
          this.fetchAggStats("Cancelled", null, null),
        ]);
      } else {
        await Promise.all([
          getOrdersListRedux(orderStatus2, null),
          this.fetchAggStats(orderStatus2, null, null),
        ]);
      }

      this.setState({ loading4: false });
    }
  };

  calculateCart = (orders) => {
    let cartProducts = orders;
    let sumAmount = 0;
    let actualOrder = 0;

    //find and create array
    cartProducts &&
      cartProducts.length > 0 &&
      cartProducts.forEach((item, index) => {
        let price = this.getPrice4(item);
        let salePrice = this.getPrice2(item);
        console.log(price);
        console.log(item.quantity);
        actualOrder += parseInt(parseInt(price) * item.quantity);
        sumAmount += parseInt(parseInt(salePrice) * item.quantity);
      });

    return { actualOrder, sumAmount };
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };

  getDeliveryAddress = (orderObj) => {
    if (orderObj && orderObj.deliveryAddress) return orderObj.deliveryAddress;
    let deliveryAddress = null;
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.address &&
      orderObj.currentUser.address.length > 0
    ) {
      deliveryAddress = orderObj.currentUser?.address?.find(
        (address) => address.defaultShipping,
      );
    } else if (
      orderObj &&
      orderObj.guest &&
      orderObj.guest.address &&
      orderObj.guest.address.length > 0
    ) {
      deliveryAddress = orderObj.guest?.address?.find(
        (address) => address.defaultShipping,
      );
    }
    return deliveryAddress;
  };

  createNotification = (order) => {
    let msg;
    console.log(order);

    if (order.orderStatus === "Processing") {
      msg = {
        title: "Order Processing",
        body: `We are processing your order.One of our team member is assigned for your order. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "Confirmed") {
      msg = {
        title: "Order Confirmed",
        body: `Your order is confirmed. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "Packing") {
      msg = {
        title: "Reday for delivery",
        body: `We are packaging your order. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "On the way") {
      msg = {
        title: "On the way",
        body: `Your parcel is out for delivery. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "Delivered") {
      msg = {
        title: "Order delivered successfully",
        body: `Your order is delivered. OrderId:-${order.id}. Thank you`,
      };
      return msg;
    }
    if (order.orderStatus === "Cancelled") {
      msg = {
        title: "Sorry. Order cancelled",
        body: `Your order is cancelled. OrderId:-${order.id}.Contact our customer service to get detail info.Thanks`,
      };
      return msg;
    }
  };

  handleCourier = async (codAmount) => {
    const { orderObj } = this.state;
    let note = this.state.note;
    if (this.state.courier == "SteadFast") {
      const create_order = `${base_url}/create_order`;

      console.log(note);
      axios
        .post(
          create_order,
          {
            invoice: `${orderObj.id}`,
            recipient_name: orderObj.currentUser
              ? orderObj.currentUser?.address?.find(
                  (address) => address.defaultShipping,
                )?.fullName
              : orderObj.guest?.address?.find(
                  (address) => address.defaultShipping,
                )?.fullName,
            recipient_phone: orderObj.currentUser
              ? orderObj.currentUser?.address?.find(
                  (address) => address.defaultShipping,
                )?.mobileNo
              : orderObj.guest?.address?.find(
                  (address) => address.defaultShipping,
                )?.mobileNo,
            recipient_address: orderObj.currentUser
              ? `${
                  orderObj.currentUser?.address?.find(
                    (address) => address.defaultShipping,
                  )?.address
                },${
                  orderObj.currentUser?.address?.find(
                    (address) => address.defaultShipping,
                  )?.district
                },${
                  orderObj.currentUser?.address?.find(
                    (address) => address.defaultShipping,
                  )?.division
                }`
              : `${
                  orderObj.guest?.address?.find(
                    (address) => address.defaultShipping,
                  )?.address
                },${
                  orderObj.guest?.address?.find(
                    (address) => address.defaultShipping,
                  )?.district
                },${
                  orderObj.guest?.address?.find(
                    (address) => address.defaultShipping,
                  )?.division
                }`,
            cod_amount: codAmount,
            note: note,
          }, // Request body (if needed)
          {
            headers: {
              "Api-Key": api_key,
              "Secret-Key": secret_key,
              "Content-Type": "application/json",
            },
          },
        )
        .then(async (response) => {
          console.log(note);
          await this.props.updateOrderRedux({
            ...orderObj,
            courier: { ...response.data, note: note },
          });
          toast.success(
            "Consignment has been created successfully at steadfast!",
          );
          window.document.getElementById("close-btn-courier").click();
        })
        .catch((error) => {
          toast.error("Error creating consignment at steadfast.");
        });
      console.log("Handle submit is getting called!");
    } else {
      // for pathao
      // first get the access token
      if (!this.state.cityObject) {
        notifyWarning("You must choose a city");
        return;
      }
      if (!this.state.zoneObject) {
        notifyWarning("You must choose a zone");
        return;
      }
      if (!this.state.access_token) {
        notifyError(
          "Your token is expired. Please open and close the modal windo again",
        );
        window.document.getElementById("close-btn-courier").click();
        return;
      }

      let baseUrl = ``;

      let totalQuantity = 0;
      orderObj.orders.map((order) => {
        totalQuantity += order.quantity;
      });
      // create order here
      let order = {
        store_id: 151431,
        merchant_order_id: `${orderObj.id}`,
        recipient_name: orderObj.currentUser
          ? orderObj.currentUser?.address?.find(
              (address) => address.defaultShipping,
            )?.fullName
          : orderObj.guest?.address?.find((address) => address.defaultShipping)
              ?.fullName,
        recipient_phone: orderObj.currentUser
          ? orderObj.currentUser?.address?.find(
              (address) => address.defaultShipping,
            )?.mobileNo
          : orderObj.guest?.address?.find((address) => address.defaultShipping)
              ?.mobileNo,
        recipient_address: orderObj.currentUser
          ? `${
              orderObj.currentUser?.address?.find(
                (address) => address.defaultShipping,
              )?.address
            },${
              orderObj.currentUser?.address?.find(
                (address) => address.defaultShipping,
              )?.district
            },${
              orderObj.currentUser?.address?.find(
                (address) => address.defaultShipping,
              )?.division
            }`
          : `${
              orderObj.guest?.address?.find((address) => address.defaultShipping)
                ?.address
            },${
              orderObj.guest?.address?.find((address) => address.defaultShipping)
                ?.district
            },${
              orderObj.guest?.address?.find((address) => address.defaultShipping)
                ?.division
            }`,
        delivery_type: 48,
        item_type: 2,
        special_instruction: note,
        item_quantity: parseInt(totalQuantity),
        item_weight: this.state.weight
          ? parseFloat(this.state.weight).toFixed(2)
          : parseFloat(1),
        item_description: "",
        amount_to_collect: parseInt(codAmount),
        recipient_city: parseInt(this.state.cityObject.city_id),
        recipient_zone: parseInt(this.state.zoneObject.zone_id),
      };
      console.log(order);
      axios
        .post(`${baseUrl}/api/create-order`, order, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.state.access_token}`,
          },
        })
        .then(async (response) => {
          console.log(response);
          if (response.data.code == 200) {
            console.log(note);
            await this.props.updateOrderRedux({
              ...orderObj,
              courier: {
                ...response.data.data,
                pathao: true,
                weight: this.state.weight ? this.state.weight : 1,
                city: this.state.cityObject,
                zone: this.state.zoneObject,
                note: note,
              },
            });
            toast.success(
              "Consignment has been created successfully at pathao!",
            );
          } else {
            notifyError("error creating consignment. Please try again later.");
          }
        })
        .catch((error) => {
          notifyError("error creating order.");
        });
    }

    this.setState({
      name: "",
      quantity: "",
      amount: "",
      description: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
    });
  };

  getUserName = (agentId) => {
    const { users } = this.props;
    if (users.length > 0) {
      const agentName = users.find((user) => user.uid === agentId);
      if (agentName) {
        return agentName.displayName;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  toggleSelectOrder = (id) => {
    this.setState((s) => ({
      selectedOrderIds: s.selectedOrderIds.includes(id)
        ? s.selectedOrderIds.filter((x) => x !== id)
        : [...s.selectedOrderIds, id],
    }));
  };

  toggleSelectAll = (orders) => {
    const { selectedOrderIds } = this.state;
    const allIds = orders.map((o) => o.id);
    const allSelected = allIds.every((id) => selectedOrderIds.includes(id));
    this.setState({ selectedOrderIds: allSelected ? [] : allIds });
  };

  handleBulkStatusChange = async () => {
    const NEXT_STATUS = {
      Processing: "Confirmed",
      Confirmed: "Packing",
      Packing: "On the way",
      "On the way": "Delivered",
      "Partial Delivered": "Delivered",
    };
    const currentStatus = this.props.match.params.orderStatus;
    const nextStatus = NEXT_STATUS[currentStatus];
    const { selectedOrderIds } = this.state;
    if (!nextStatus || selectedOrderIds.length === 0) return;
    if (
      !(await confirmDialog(
        `Move ${selectedOrderIds.length} order(s) to "${nextStatus}"?`,
        { danger: false, confirmText: "Move" },
      ))
    )
      return;
    this.setState({ bulkLoading: true });
    try {
      await this.props.bulkUpdateOrderStatusRedux(selectedOrderIds, nextStatus);
      toast.success(
        `${selectedOrderIds.length} order(s) moved to ${nextStatus}.`,
      );
      this.setState({ selectedOrderIds: [] });
    } catch (e) {
      toast.error("Bulk update failed: " + e.message);
    }
    this.setState({ bulkLoading: false });
  };

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
      });
    } else {
      this.setState({
        checkedValues: [...this.state.checkedValues, i],
      });
    }
  };
  selectRow2 = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues2: this.state.checkedValues2.filter(
          (item, j) => i !== item,
        ),
      });
    } else {
      this.setState({
        checkedValues2: [...this.state.checkedValues2, i],
      });
    }
  };

  singleProductTotal = (product) => {
    let total = parseInt(this.getPrice2(product)) * product.quantity;
    return total;
  };

  getPrice2 = (product) => {
    if (product.selectedVariation?.id) {
      if (product.selectedVariation?.salePrice == 0) {
        return product.selectedVariation?.price;
      } else {
        return product.selectedVariation?.salePrice;
      }
    } else {
      if (product.product) {
        if (product.product.salePrice == 0) {
          return product.product.price;
        } else {
          return product.product.salePrice;
        }
      } else {
        return 0;
      }
    }
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmit = async () => {
    console.log("Handle submit is getting called!");
    let orderObj = {
      ...this.state.orderObj,
      orderStatus: this.state.orderStatus,
      [`${this.state.orderStatus.toLowerCase()}Date`]: new Date()
        .getTime()
        .toString(),
      orderStatusScore:
        this.state.orderStatus == "Processing"
          ? 2
          : this.state.orderStatus == "Confirmed"
            ? 3
            : this.state.orderStatus == "Packing"
              ? 4
              : this.state.orderStatus == "On the way"
                ? 5
                : this.state.orderStatus == "Delivered"
                  ? 6
                  : 0,
      cancelNote: this.state.cancelNote,
    };

    await this.props.updateOrderRedux(orderObj);
    const msg = this.createNotification(orderObj);
    const message = {
      title: msg.title,
      body: msg.body,
    };
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.deviceToken &&
      orderObj.currentUser.deviceToken.length > 0
    ) {
      orderObj.currentUser.deviceToken.map((token) => {
        console.log(token);
        sendNotifications(token, message);
      });
    }

    for (let i = 0; i < orderObj.orders.length; i++) {
      let product = await getSingleProduct(orderObj.orders[i].productId);
      let order = orderObj.orders[i];
      if (!product) continue;
      if (this.state.orderStatus == "Cancelled") {
        if (
          product.displayedVariations &&
          product.displayedVariations.length > 0
        ) {
          await this.props.updateSingleProductRedux({
            ...product,
            displayedVariations: product.displayedVariations.map(
              (variation) => {
                if (order.selectedVariation?.id == variation.id) {
                  return {
                    ...variation,
                    totalSold: variation.totalSold
                      ? variation.totalSold - parseInt(order.quantity)
                      : 0,
                    inventory:
                      parseInt(variation.inventory) +
                      parseInt(
                        orderObj.orders.find(
                          (order) => order.selectedVariation?.id == variation.id,
                        ).quantity,
                      ),
                  };
                } else {
                  return variation;
                }
              },
            ),
          });
          let date = new Date();
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + i,
            fundType: "Buying",
            subCategory: `Order Id:${orderObj.id}`,
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            purchasePrice: "Cancelled by admin",
            cancelNote: this.state.cancelNote,
            orderStatus: "Cancelled",
            totalCost: this.singleProductTotal(orderObj.orders[i]),
            perUnitPrice: this.getPrice2(orderObj.orders[i]),
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            unEditable: true,
            productId: product.id,
            productStock: orderObj.orders[i].quantity,
            remainingStock:
              parseInt(
                product.displayedVariations.find(
                  (variation) => variation.id == order.selectedVariation?.id,
                )?.inventory || 0,
              ) + parseInt(order.quantity),
            productName: product.name,
            productImage: product.pictures[0],
            variationId: order.selectedVariation?.id,
          });
        } else {
          await this.props.updateSingleProductRedux({
            ...product,
            totalSold: product.totalSold
              ? parseInt(product.totalSold) -
                parseInt(orderObj.orders[i].quantity)
              : 0,
            inventory:
              parseInt(product.inventory) +
              parseInt(orderObj.orders[i].quantity),
          });
          let date = new Date();
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + i,
            fundType: "Buying",
            subCategory: `Order Id:${orderObj.id}`,
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            purchasePrice: "Cancelled by admin",
            cancelNote: this.state.cancelNote,
            orderStatus: "Cancelled",
            totalCost: this.singleProductTotal(orderObj.orders[i]),
            perUnitPrice: this.getPrice2(orderObj.orders[i]),
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            unEditable: true,
            productId: product.id,
            productStock: orderObj.orders[i].quantity,
            remainingStock:
              parseInt(product.inventory) +
              parseInt(orderObj.orders[i].quantity),
            productName: product.name,
            productImage: product.pictures[0],
          });
        }
      }
    }
    await updateTransactionOrderStatus({
      orderId: orderObj.id,
      orderStatus: this.state.orderStatus,
    });
    this.setState({
      name: "",
      quantity: "",
      amount: "",
      description: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
      cancelNote: "",
    });
  };
  handleSubmit2 = async (event, totalDue) => {
    event.preventDefault();

    if (totalDue != 0 && this.state.amount == 0) {
      notifyWarning("Paid amount must be more than 0");
      return;
    }
    if (this.state.amount > totalDue) {
      notifyWarning("Paid amount can't be more than due amount.");
      return;
    }
    console.log(this.state);
    if (this.state.loader) {
      return;
    }
    this.setState({
      loader: true,
    });
    await this.props.updateOrderRedux({
      ...this.state.orderObj,
      paymentStatus:
        this.state.paymentStatus !== ""
          ? this.state.paymentStatus
          : this.state.orderObj.paymentStatus
            ? this.state.orderObj.paymentStatus
            : "purchaseLater",
      payments:
        this.state.orderObj.payments && this.state.orderObj.payments.length > 0
          ? [
              ...this.state.orderObj.payments,
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ]
          : [
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ],
    });

    orderCache[this.state.orderObj.id] = {
      ...this.state.orderObj,
      paymentStatus:
        this.state.paymentStatus !== ""
          ? this.state.paymentStatus
          : this.state.orderObj.paymentStatus
            ? this.state.orderObj.paymentStatus
            : "purchaseLater",
      payments:
        this.state.orderObj.payments && this.state.orderObj.payments.length > 0
          ? [
              ...this.state.orderObj.payments,
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ]
          : [
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ],
    };

    let date = new Date();
    let cashInObj = {
      id: date.getTime().toString(),
      category: "ORDERS",
      subCategory: this.state.method,
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Order Id:${this.state.orderObj.id}`,
      amount: this.state.amount,
      receiveBy:
        this.props.currentAdmin && this.props.currentAdmin.name
          ? this.props.currentAdmin.name
          : "",
      status: "pending",
      unEditable: true,
    };

    await this.props.uploadCashInRedux(cashInObj);
    toast.success("successfully updated the payment");

    this.setState({
      method: "",
      amount: "",
      paymentStatus: "",
      transactionId: "",
      loader: false,
    });
    document.getElementById("close-button-for-payment-modal").click();
  };
  handleSubmit3 = async (event) => {
    event.preventDefault();

    console.log(this.state);
    if (this.state.loader3) {
      return;
    }
    this.setState({
      loader3: true,
    });
    await this.props.updateOrderRedux({
      ...this.state.orderObj,
      courierCharge: this.state.orderObj.courierCharge
        ? parseInt(this.state.orderObj.courierCharge) +
          parseInt(this.state.courierCharge)
        : this.state.courierCharge,
    });

    orderCache[this.state.orderObj.id] = {
      ...this.state.orderObj,
      courierCharge: this.state.orderObj.courierCharge
        ? parseInt(this.state.orderObj.courierCharge) +
          parseInt(this.state.courierCharge)
        : this.state.courierCharge,
    };
    let date = new Date();
    let expenseObj = {
      id: date.getTime().toString(),
      category: "COURIER",
      subCategory: `courier charge`,
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Order Id:${this.state.orderObj.id}`,
      amount: this.state.courierCharge,
      receiveBy:
        this.props.currentAdmin && this.props.currentAdmin.name
          ? this.props.currentAdmin.name
          : "",
      status: "pending",
      unEditable: true,
    };

    await this.props.uploadExpenseRedux(expenseObj);
    toast.success("successfully updated the payment");

    this.setState({
      method: "",
      amount: "",
      paymentStatus: "",
      transactionId: "",
      loader: false,
      courierCharge: "",
      loader3: false,
    });
    document.getElementById("close-button-for-payment-modal").click();
  };
  handleSteadfastClick = async (order) => {
    await this.onClick(order);
    this.setState({
      courier: "SteadFast",
      fraudModalOpen: true,
      fraudCheckLoading: true,
      fraudData: null,
    });
    const phone = this.getDeliveryAddress(order)?.mobileNo;
    try {
      const response = await axios.get(`${base_url}/fraud_check/${phone}`, {
        headers: {
          "Api-Key": api_key,
          "Secret-Key": secret_key,
          "Content-Type": "application/json",
        },
      });
      this.setState({ fraudData: response.data, fraudCheckLoading: false });
    } catch (e) {
      this.setState({ fraudCheckLoading: false, fraudData: { error: true } });
    }
  };

  handleFraudProceed = () => {
    this.setState({ fraudModalOpen: false });
    window.$("#courierModal").modal("show");
  };

  handleSubmitMerged = async (event) => {
    event.preventDefault();

    const hasPaidAmount = this.state.amount !== "" && this.state.amount != null;
    const hasCourierCharge =
      this.state.courierCharge !== "" && this.state.courierCharge != null;

    if (!hasPaidAmount && !hasCourierCharge) {
      return notifyWarning("Please enter a paid amount or a courier charge.");
    }
    if (hasPaidAmount) {
      if (!this.state.method)
        return notifyWarning("Please select a payment method.");
      if (!this.state.paymentStatus)
        return notifyWarning("Please select a payment status.");
      if (!this.state.transactionId)
        return notifyWarning("Please enter a transaction ID.");
    }
    if (this.state.loader) return;
    this.setState({ loader: true });

    const adminName =
      this.props.currentAdmin && this.props.currentAdmin.name
        ? this.props.currentAdmin.name
        : "";
    const date = new Date();

    let updatedOrder = { ...this.state.orderObj };

    if (hasPaidAmount) {
      const newPayment = {
        amount: this.state.amount,
        method: this.state.method,
        receivedBy: adminName,
        date: date.toLocaleDateString("en-GB"),
        transactionId: this.state.transactionId,
      };
      updatedOrder = {
        ...updatedOrder,
        paymentStatus:
          this.state.paymentStatus !== ""
            ? this.state.paymentStatus
            : updatedOrder.paymentStatus || "purchaseLater",
        payments:
          updatedOrder.payments && updatedOrder.payments.length > 0
            ? [...updatedOrder.payments, newPayment]
            : [newPayment],
      };
    }

    if (hasCourierCharge) {
      updatedOrder = {
        ...updatedOrder,
        courierCharge: updatedOrder.courierCharge
          ? parseInt(updatedOrder.courierCharge) +
            parseInt(this.state.courierCharge)
          : this.state.courierCharge,
      };
    }

    await this.props.updateOrderRedux(updatedOrder);
    orderCache[this.state.orderObj.id] = updatedOrder;

    if (hasPaidAmount) {
      await this.props.uploadCashInRedux({
        id: date.getTime().toString(),
        category: "ORDERS",
        subCategory: this.state.method,
        month: this.getMonthName(),
        date: date.toLocaleDateString("en-GB"),
        note: `Order Id:${this.state.orderObj.id}`,
        amount: this.state.amount,
        receiveBy: adminName,
        status: "pending",
        unEditable: true,
      });
    }

    if (hasCourierCharge) {
      await this.props.uploadExpenseRedux({
        id: (date.getTime() + 1).toString(),
        category: "COURIER",
        subCategory: "courier charge",
        month: this.getMonthName(),
        date: date.toLocaleDateString("en-GB"),
        note: `Order Id:${this.state.orderObj.id}`,
        amount: this.state.courierCharge,
        receiveBy: adminName,
        status: "pending",
        unEditable: true,
      });
    }

    toast.success("Successfully updated.");
    this.setState({
      method: "",
      amount: "",
      paymentStatus: "",
      transactionId: "",
      courierCharge: "",
      loader: false,
      loader3: false,
    });
    document.getElementById("close-button-for-payment-modal").click();
  };

  getTotalPaid = (orderObj) => {
    let totalPaid = 0;
    if (orderObj && orderObj.payments && orderObj.payments.length > 0) {
      orderObj.payments.map((payment) => {
        totalPaid += parseInt(payment.amount);
      });
    }
    return totalPaid;
  };
  getTotalDue = (orderObj) => {
    let totalPaid = 0;
    let amountPayable = 0;
    if (orderObj && orderObj.payments && orderObj.payments.length > 0) {
      orderObj.payments.map((payment) => {
        totalPaid += parseInt(payment.amount);
      });
    }
    if (orderObj) {
      amountPayable =
        orderObj &&
        orderObj.subTotal +
          orderObj.deliveryCharge -
          orderObj.discountApplied -
          (orderObj.couponApplied ? orderObj.couponApplied.discount : 0) -
          (orderObj.finalDiscount ? orderObj.finalDiscount : 0);
    }
    return amountPayable - totalPaid;
  };
  getPrice3 = (product) => {
    if (product.selectedVariation?.id) {
      if (product.selectedVariation?.salePrice == 0) {
        return "";
      } else {
        return `৳ ${product.selectedVariation?.price}`;
      }
    } else {
      if (product.product) {
        if (product.product.salePrice == 0) {
          return "";
        } else {
          return `৳ ${product.product.price}`;
        }
      } else {
        return 0;
      }
    }
  };
  getPrice4 = (product) => {
    if (product.selectedVariation?.id) {
      return product.selectedVariation?.price;
    } else {
      if (product.product) {
        return product.product.price;
      } else {
        return 0;
      }
    }
  };

  handleCashOut = async (p2pArray) => {
    const { currentAdmin } = this.props;
    let date = new Date();
    if (p2pArray.length == 0) {
      notifyWarning("Please select at least one p2p agent to pay");
      return;
    }
    for (let i = 0; i < p2pArray.length; i++) {
      const p2pObj = p2pArray[i];
      console.log(date.getTime().toString());
      console.log(p2pObj);
      await this.props.handleP2pAgentPayRedux({
        ...p2pObj,
        paymentId: `${date.getTime().toString()}${i}`,
        month: this.getMonthName(),
        date: date.toLocaleDateString("en-GB"),
        receiveBy: currentAdmin.name,
      });
    }
    this.setState({
      checkedValues2: [],
    });
  };

  updateOrder = async () => {
    console.log("Handle submit is getting called!");
    let orderObj = {
      ...this.state.orderObj,
    };
    let previousOrder = await getSingleOrder(orderObj.id);
    let previousOrdersArray = previousOrder.orders;
    let newOrdersArray = orderObj.orders;
    const getDifferenceArray = this.getDifferenceArray(
      previousOrdersArray,
      newOrdersArray,
    );
    console.log(getDifferenceArray);
    await this.props.updateOrderRedux(orderObj);
    orderCache[orderObj.id] = orderObj;
    const msg = this.createNotification(orderObj);
    const message = {
      title: msg.title,
      body: msg.body,
    };
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.deviceToken &&
      orderObj.currentUser.deviceToken.length > 0
    ) {
      orderObj.currentUser.deviceToken.map((token) => {
        console.log(token);
        sendNotifications(token, message);
      });
    }
    let orders = getDifferenceArray;
    console.log(orders);
    for (let i = 0; i < orders.length; i++) {
      let order = orders[i];
      if (orders[i].unchanged) {
      } else {
        let product = await getSingleProduct(orders[i].productId);
        if (
          product.displayedVariations &&
          product.displayedVariations.length > 0
        ) {
          if (orders[i].decreased) {
            await this.props.updateSingleProductRedux({
              ...product,
              displayedVariations: product.displayedVariations.map(
                (variation) => {
                  if (order.selectedVariation?.id == variation.id) {
                    return {
                      ...variation,
                      totalSold: variation.totalSold
                        ? variation.totalSold - parseInt(order.quantity)
                        : 0,
                      inventory:
                        parseInt(variation.inventory) +
                        parseInt(
                          orders.find(
                            (order) =>
                              order.selectedVariation?.id == variation.id,
                          ).quantity,
                        ),
                    };
                  } else {
                    return variation;
                  }
                },
              ),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Buying",
              subCategory: `Order Id:${orderObj.id}`,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              purchasePrice: "Partial delivered",
              cancelNote: "Item quantity reduced from order",
              orderStatus: orderObj.orderStatus,
              totalCost: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              unEditable: true,
              productId: product.id,
              productStock: orders[i].quantity,
              remainingStock:
                parseInt(
                  product.displayedVariations.find(
                    (variation) => variation.id == order.selectedVariation?.id,
                  )?.inventory || 0,
                ) + parseInt(order.quantity),
              productName: product.name,
              productImage: product.pictures[0],
              variationId: order.selectedVariation?.id,
            });
          }
          if (orders[i].increased) {
            await this.props.updateSingleProductRedux({
              ...product,
              displayedVariations: product.displayedVariations.map(
                (variation) => {
                  if (order.selectedVariation?.id == variation.id) {
                    return {
                      ...variation,
                      totalSold: variation.totalSold
                        ? variation.totalSold + parseInt(order.quantity)
                        : parseInt(order.quantity),
                      inventory:
                        parseInt(variation.inventory) -
                        parseInt(
                          orders.find(
                            (order) =>
                              order.selectedVariation?.id == variation.id,
                          ).quantity,
                        ),
                    };
                  } else {
                    return variation;
                  }
                },
              ),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Selling",
              subCategory: `Order Id:${orderObj.id}`,
              orderStatus: orderObj.orderStatus,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              totalBill: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              note: "Increased quantity",
              unEditable: true,
              productId: product.id,
              sellStock: orders[i].quantity,
              remainingStock:
                parseInt(
                  product.displayedVariations.find(
                    (variation) => variation.id == order.selectedVariation?.id,
                  )?.inventory || 0,
                ) - parseInt(order.quantity),
              productName: product.name,
              productImage: product.pictures[0],
              variationId: order.selectedVariation?.id,
            });
          }
        } else {
          if (orders[i].decreased) {
            await this.props.updateSingleProductRedux({
              ...product,
              totalSold: product.totalSold
                ? parseInt(product.totalSold) - parseInt(orders[i].quantity)
                : 0,
              inventory:
                parseInt(product.inventory) + parseInt(orders[i].quantity),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Buying",
              subCategory: `Order Id:${orderObj.id}`,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              purchasePrice: "Partial delivered",
              cancelNote: "Item quantity reduced from order",
              orderStatus: orderObj.orderStatus,
              totalCost: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              unEditable: true,
              productId: product.id,
              productStock: orders[i].quantity,
              remainingStock:
                parseInt(product.inventory) + parseInt(orders[i].quantity),
              productName: product.name,
              productImage: product.pictures[0],
            });
          }
          if (orders[i].increased) {
            await this.props.updateSingleProductRedux({
              ...product,
              totalSold: product.totalSold
                ? product.totalSold + parseInt(orders[i].quantity)
                : parseInt(orders[i].quantity),
              inventory:
                parseInt(product.inventory) - parseInt(orders[i].quantity),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Selling",
              subCategory: `Increased quantity in Order Id:${orderObj.id}`,
              orderStatus: orderObj.orderStatus,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              totalBill: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              unEditable: true,
              productId: product.id,
              sellStock: orders[i].quantity,
              remainingStock:
                parseInt(product.inventory) - parseInt(orders[i].quantity),
              productName: product.name,
              productImage: product.pictures[0],
            });
          }
        }
      }
    }

    this.setState({
      name: "",
      quantity: "",
      amount: "",
      description: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
      cancelNote: "",
    });
  };

  getProductKey = (product) =>
    `${product.productId}-${product.selectedVariation?.id}`;

  // Function to get the difference array
  getDifferenceArray = (array1, array2) => {
    // Create a map of array1 for faster lookup
    const mapArray1 = array1.reduce((acc, item) => {
      const key = this.getProductKey(item);
      if (!acc[key]) {
        acc[key] = item;
      } else {
        acc[key].quantity += item.quantity; // In case there are duplicate productIds with different variations
      }
      return acc;
    }, {});

    // Create the result array
    const result = [];

    // Check for changes based on array2
    array2.forEach((item2) => {
      const key = this.getProductKey(item2);
      const item1 = mapArray1[key];

      if (item1) {
        // Product exists in both arrays, compare quantities
        if (item2.quantity > item1.quantity) {
          result.push({
            ...item2,
            quantity: item2.quantity - item1.quantity,
            increased: true,
          });
        } else if (item2.quantity < item1.quantity) {
          result.push({
            ...item2,
            quantity: item1.quantity - item2.quantity,
            decreased: true,
          });
        } else {
          result.push({
            ...item2,
            unchanged: true,
          });
        }

        // Remove the item from mapArray1 (it has been handled)
        delete mapArray1[key];
      } else {
        // Product exists in array2 but not in array1 (newly added)
        result.push({
          ...item2,
          increased: true,
        });
      }
    });

    // Check for removed items in array1 (those that are not in array2)
    Object.values(mapArray1).forEach((item1) => {
      result.push({
        ...item1,
        quantity: item1.quantity,
        decreased: true,
      });
    });

    return result;
  };
  onClick = async (order) => {
    // Clear immediately so the modal never shows stale data from the previous order
    this.setState({ orderObj: null });

    const orderId = order.id;
    let orderData;

    if (orderCache[orderId]) {
      orderData = orderCache[orderId];
    } else {
      orderData = await getSingleOrder(orderId);
      orderCache[orderId] = orderData;
    }

    this.setState({ orderObj: orderData });
  };

  render() {
    const { orderObj, loading4 } = this.state;
    const { orders, hasMore } = this.props;
    const { orderStatus } = this.props.match.params;
    let renderableOrders = orders;
    if (this.state.searchFor) {
      renderableOrders = orders.filter(
        (order) =>
          order.id
            .toString()
            .toLowerCase()
            .includes(this.state.searchFor.toLowerCase()) ||
          (order.currentUser &&
            order.currentUser.displayName
              .toLowerCase()
              .includes(this.state.searchFor.toLowerCase())),
      );
    }
    let deliveryAddress = null;
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.address &&
      orderObj.currentUser.address.length > 0
    ) {
      deliveryAddress = orderObj.currentUser?.address?.find(
        (address) => address.defaultShipping,
      );
    } else if (
      orderObj &&
      orderObj.guest &&
      orderObj.guest.address &&
      orderObj.guest.address.length > 0
    ) {
      deliveryAddress = orderObj.guest?.address?.find(
        (address) => address.defaultShipping,
      );
    }

    let totalPaid = 0;
    if (orderObj && orderObj.payments && orderObj.payments.length > 0) {
      orderObj.payments.map((payment) => {
        totalPaid += parseInt(payment.amount);
      });
    }
    let amountPayable = 0;
    if (orderObj) {
      amountPayable =
        orderObj &&
        orderObj.subTotal +
          orderObj.deliveryCharge -
          orderObj.discountApplied -
          (orderObj.couponApplied ? orderObj.couponApplied.discount : 0) -
          (orderObj.finalDiscount ? orderObj.finalDiscount : 0);
    }
    return (
      <Fragment>
        <Breadcrumb title={orderStatus} parent="Orders" />
        {loading4 && <FullPageLoader />}

        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-sm-12">
              <div className="card" id="taobao-orders-card">
                <div
                  className="card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderBottom: "1px solid gainsboro",
                  }}
                >
                  <div>
                    <h5>
                      <i
                        className="icofont-money"
                        style={{
                          fontSize: "130%",
                          marginRight: "5px",
                          color: "#7C3AED",
                        }}
                      ></i>
                      {orderStatus}
                    </h5>
                  </div>
                  <div
                    style={{
                      background: "#00B795",
                      color: "white",
                      padding: 10,
                      borderRadius: 10,
                      fontWeight: "bold",
                      cursor: "pointer",
                      minWidth: 200,
                      textAlign: "center",
                    }}
                    onClick={async () => {
                      console.log(this.state.balance);
                      if (!this.state.balance) {
                        console.log(this.state.balance);
                        let response = await axios.get(
                          `${base_url}/get_balance`,
                          {
                            headers: {
                              "Api-Key": api_key,
                              "Secret-Key": secret_key,
                              "Content-Type": "application/json",
                            },
                          },
                        );
                        console.log(response.data);
                        let response2 = await axios.get(
                          `${base_url}/get_return_requests`,
                          {
                            headers: {
                              "Api-Key": api_key,
                              "Secret-Key": secret_key,
                              "Content-Type": "application/json",
                            },
                          },
                        );
                        console.log(response2.data);
                        if (response.data) {
                          this.setState({
                            balance: `Tk ${response.data.current_balance}`,
                          });
                        }
                      }
                    }}
                  >
                    {this.state.balance
                      ? `${this.state.balance} `
                      : "👆🏻 Steadfast Balance"}
                  </div>
                  {this.props.currentAdmin &&
                    this.props.currentAdmin.status === "Admin" && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <button
                          onClick={this.handleMigrateOrders}
                          disabled={
                            this.state.migrating || this.state.migrationDone
                          }
                          style={{
                            padding: "7px 14px",
                            borderRadius: 8,
                            border: "1px solid #6C63FF",
                            background: this.state.migrationDone
                              ? "#F0FDF4"
                              : "white",
                            color: this.state.migrationDone
                              ? "#15803D"
                              : "#6C63FF",
                            fontSize: 12,
                            fontWeight: 700,
                            cursor:
                              this.state.migrating || this.state.migrationDone
                                ? "not-allowed"
                                : "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {this.state.migrating
                            ? `Migrating… ${this.state.migratedCount} done`
                            : this.state.migrationDone
                              ? `✓ Migrated ${this.state.migratedCount}`
                              : "Migrate → ordersList"}
                        </button>
                        <button
                          onClick={this.handleCheckCounts}
                          disabled={this.state.countLoading}
                          style={{
                            padding: "7px 14px",
                            borderRadius: 8,
                            border: "1px solid #94a3b8",
                            background: "white",
                            color: "#475569",
                            fontSize: 12,
                            fontWeight: 700,
                            cursor: this.state.countLoading
                              ? "not-allowed"
                              : "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {this.state.countLoading
                            ? "Counting…"
                            : "Check Counts"}
                        </button>
                        <button
                          onClick={this.handleRecalculateOrderStats}
                          disabled={
                            this.state.recalculatingStats ||
                            this.state.recalculateStatsDone
                          }
                          title="Rebuilds the ORDERS/BILL/PAID/DUE/DISCOUNT stat tiles from scratch — use this if the numbers look out of sync with the actual order list."
                          style={{
                            padding: "7px 14px",
                            borderRadius: 8,
                            border: "1px solid #F97316",
                            background: this.state.recalculateStatsDone
                              ? "#F0FDF4"
                              : "white",
                            color: this.state.recalculateStatsDone
                              ? "#15803D"
                              : "#F97316",
                            fontSize: 12,
                            fontWeight: 700,
                            cursor:
                              this.state.recalculatingStats ||
                              this.state.recalculateStatsDone
                                ? "not-allowed"
                                : "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {this.state.recalculatingStats
                            ? `Recalculating… ${this.state.recalculatedCount} done`
                            : this.state.recalculateStatsDone
                              ? `✓ Recalculated ${this.state.recalculatedCount}`
                              : "Recalculate Order Stats"}
                        </button>
                        {this.state.collectionCounts &&
                          (() => {
                            const { orders, ordersList } =
                              this.state.collectionCounts;
                            const missing = orders - ordersList;
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  gap: 6,
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  style={{
                                    background: "#EEF2FF",
                                    color: "#3730A3",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    padding: "3px 8px",
                                    borderRadius: 5,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  orders: {orders}
                                </span>
                                <span
                                  style={{
                                    background: "#F0FDF4",
                                    color: "#166534",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    padding: "3px 8px",
                                    borderRadius: 5,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  ordersList: {ordersList}
                                </span>
                                {missing > 0 ? (
                                  <span
                                    style={{
                                      background: "#FEF2F2",
                                      color: "#991B1B",
                                      fontSize: 11,
                                      fontWeight: 700,
                                      padding: "3px 8px",
                                      borderRadius: 5,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    missing: {missing}
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      background: "#F0FDF4",
                                      color: "#166534",
                                      fontSize: 11,
                                      fontWeight: 700,
                                      padding: "3px 8px",
                                      borderRadius: 5,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    ✓ in sync
                                  </span>
                                )}
                              </div>
                            );
                          })()}
                      </div>
                    )}
                  <li
                    style={{
                      border: "1px solid gainsboro",
                      borderRadius: "5rem",
                      padding: "0px 20px",
                      background: "whitesmoke",
                      marginRight: "20px",
                    }}
                  >
                    <form className="form-inline search-form">
                      <div
                        // className="form-group"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-around",
                        }}
                      >
                        <input
                          className={
                            "form-control-plaintext " +
                            (this.state.searchbar ? "open" : "")
                          }
                          name="searchFor"
                          value={this.state.searchFor}
                          type="search"
                          placeholder="Search Order"
                          onChange={this.handleSearchBarChange}
                        />
                        <span>
                          <Search
                            style={{
                              marginTop: "5px",
                              borderLeft: "1px solid gainsboro",
                              paddingLeft: "7px",
                              color: "gray",
                            }}
                          />
                        </span>
                      </div>
                    </form>
                  </li>
                </div>


                {(() => {
                  const { aggStats, aggLoading } = this.state;
                  const summaryPills = [
                    {
                      label: "Orders",
                      value: aggStats ? aggStats.orderCount : 0,
                      bg: "#F1F5F9",
                      color: "#475569",
                      border: "#E2E8F0",
                      prefix: "",
                    },
                    {
                      label: "Bill",
                      value: aggStats ? aggStats.totalBill : 0,
                      bg: "#F0F9FF",
                      color: "#0369A1",
                      border: "#BAE6FD",
                      prefix: "৳ ",
                    },
                    {
                      label: "Paid",
                      value: aggStats ? aggStats.totalPaid : 0,
                      bg: "#F0FDF4",
                      color: "#15803D",
                      border: "#BBF7D0",
                      prefix: "৳ ",
                    },
                    {
                      label: "Due",
                      value: aggStats ? aggStats.totalDue : 0,
                      bg: "#FEF2F2",
                      color: "#991B1B",
                      border: "#FECACA",
                      prefix: "৳ ",
                    },
                    {
                      label: "Discount",
                      value: aggStats ? aggStats.totalDiscount : 0,
                      bg: "#FFF7ED",
                      color: "#C2410C",
                      border: "#FED7AA",
                      prefix: "৳ ",
                    },
                    ...(orderStatus === "All Orders"
                      ? [
                          {
                            label: "Cancelled",
                            value: aggStats ? aggStats.cancelledCount : 0,
                            bg: "#F8FAFC",
                            color: "#64748B",
                            border: "#CBD5E1",
                            prefix: "",
                          },
                        ]
                      : []),
                  ];

                  return (
                    <div
                      style={{
                        padding: "10px 20px",
                        borderBottom: "1px solid #E8ECF0",
                        background: "#FAFBFF",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        flexWrap: "wrap",
                      }}
                    >
                      {orderStatus === "All Orders" && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            flexWrap: "wrap",
                          }}
                        >
                          {[
                            { key: "today", label: "Today" },
                            { key: "last-30", label: "Last 30 Days" },
                            { key: "last-6-months", label: "Last 6 Months" },
                          ].map(({ key, label }) => (
                            <button
                              key={key}
                              onClick={() => this.setDateFilter(key)}
                              style={{
                                padding: "5px 14px",
                                borderRadius: 20,
                                border: `1.5px solid ${this.state.dateFilter === key ? "#6D28D9" : "#E2E8F0"}`,
                                background:
                                  this.state.dateFilter === key
                                    ? "#EDE9FE"
                                    : "#fff",
                                color:
                                  this.state.dateFilter === key
                                    ? "#6D28D9"
                                    : "#64748B",
                                fontSize: 12,
                                fontWeight:
                                  this.state.dateFilter === key ? 700 : 500,
                                cursor: "pointer",
                                transition: "all 0.12s ease",
                              }}
                            >
                              {label}
                            </button>
                          ))}

                          <div
                            style={{
                              width: 1,
                              height: 22,
                              background: "#E2E8F0",
                              margin: "0 4px",
                            }}
                          />

                          <input
                            type="date"
                            value={this.state.customStartDate}
                            onChange={(e) =>
                              this.setState({ customStartDate: e.target.value })
                            }
                            style={{
                              fontSize: 12,
                              padding: "4px 8px",
                              border: "1.5px solid #E2E8F0",
                              borderRadius: 8,
                              color: "#374151",
                              outline: "none",
                            }}
                          />
                          <span style={{ color: "#94A3B8", fontSize: 12 }}>
                            →
                          </span>
                          <input
                            type="date"
                            value={this.state.customEndDate}
                            onChange={(e) =>
                              this.setState({ customEndDate: e.target.value })
                            }
                            style={{
                              fontSize: 12,
                              padding: "4px 8px",
                              border: "1.5px solid #E2E8F0",
                              borderRadius: 8,
                              color: "#374151",
                              outline: "none",
                            }}
                          />
                          <button
                            onClick={this.applyCustomRange}
                            disabled={
                              !this.state.customStartDate ||
                              !this.state.customEndDate
                            }
                            style={{
                              padding: "5px 14px",
                              borderRadius: 8,
                              border: "none",
                              background:
                                this.state.customStartDate &&
                                this.state.customEndDate
                                  ? "linear-gradient(135deg, #6D28D9, #4F46E5)"
                                  : "#E2E8F0",
                              color:
                                this.state.customStartDate &&
                                this.state.customEndDate
                                  ? "#fff"
                                  : "#94A3B8",
                              fontSize: 12,
                              fontWeight: 600,
                              cursor:
                                this.state.customStartDate &&
                                this.state.customEndDate
                                  ? "pointer"
                                  : "default",
                            }}
                          >
                            Apply
                          </button>
                        </div>
                      )}

                      <div
                        style={{
                          marginLeft: "auto",
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        {aggLoading ? (
                          <span style={{ fontSize: 12, color: "#94A3B8" }}>
                            <ClipLoader size={12} color="#6D28D9" /> Loading
                            stats…
                          </span>
                        ) : (
                          summaryPills.map(
                            ({ label, value, bg, color, border, prefix }) => (
                              <div
                                key={label}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  padding: "4px 10px",
                                  borderRadius: 10,
                                  background: bg,
                                  border: `1px solid ${border}`,
                                  minWidth: 64,
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: 10,
                                    fontWeight: 600,
                                    color: "#94A3B8",
                                    letterSpacing: "0.06em",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {label}
                                </span>
                                <span
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 800,
                                    color,
                                    lineHeight: 1.3,
                                  }}
                                >
                                  {prefix}
                                  {value.toLocaleString()}
                                </span>
                              </div>
                            ),
                          )
                        )}
                      </div>
                    </div>
                  );
                })()}

                <div className="card-body">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          background: "#00b795",
                          color: "white",
                          fontWeight: "bold",
                          fontSize: 13,
                          padding: "10px 10px",
                          borderRadius: 5,
                          display: "inline-block",
                          textAlign: "center",
                          minWidth: 250,
                          cursor: "pointer",
                        }}
                        onClick={async () => {
                          if (this.state.loader) return;
                          this.setState({ loader: true });
                          let updatedCount = 0;
                          try {
                            const notDeliveredOrders = orders.filter(
                              (order) => order.orderStatus !== "Delivered",
                            );
                            for (
                              let i = 0;
                              i < notDeliveredOrders.length;
                              i++
                            ) {
                              const order = notDeliveredOrders[i];
                              if (
                                order.courier &&
                                order.courier.consignment &&
                                order.courier.consignment.consignment_id
                              ) {
                                try {
                                  const response = await axios.get(
                                    `${base_url}/status_by_cid/${order.courier.consignment.consignment_id}`,
                                    {
                                      headers: {
                                        "Api-Key": api_key,
                                        "Secret-Key": secret_key,
                                        "Content-Type": "application/json",
                                      },
                                    },
                                  );
                                  if (
                                    response.data &&
                                    response.data.delivery_status ===
                                      "delivered"
                                  ) {
                                    await this.props.updateOrderRedux({
                                      ...order,
                                      orderStatus: "Delivered",
                                      deliveredDate: new Date()
                                        .getTime()
                                        .toString(),
                                      orderStatusScore: 6,
                                    });
                                    await updateTransactionOrderStatus({
                                      orderId: order.id,
                                      orderStatus: "Delivered",
                                    });
                                    updatedCount++;
                                  }
                                } catch (e) {
                                  console.error(
                                    `SteadFast sync failed for order ${order.id}:`,
                                    e,
                                  );
                                }
                              }
                            }
                            toast.success(
                              updatedCount > 0
                                ? `${updatedCount} order${updatedCount > 1 ? "s" : ""} marked Delivered`
                                : "No new deliveries found",
                            );
                          } catch (e) {
                            toast.error("SteadFast sync failed: " + e.message);
                          } finally {
                            this.setState({ loader: false });
                          }
                        }}
                      >
                        {this.state.loader ? (
                          <ClipLoader
                            loading={this.state.loader}
                            color="white"
                            size={14}
                          />
                        ) : (
                          "Update SteadFast Orders"
                        )}
                      </div>
                    </div>
                  </div>
                  <span style={{ fontSize: 12, fontWeight: "bold" }}>
                    Note: click the button above to get updated shipping status
                    from SteadFast
                  </span>
                  <div className="clearfix"></div>

                  {/* Bulk action bar */}
                  {(() => {
                    const NEXT_STATUS = {
                      Processing: "Confirmed",
                      Confirmed: "Packing",
                      Packing: "On the way",
                      "On the way": "Delivered",
                      "Partial Delivered": "Delivered",
                    };
                    const nextStatus = NEXT_STATUS[orderStatus];
                    if (!nextStatus || this.state.selectedOrderIds.length === 0)
                      return null;
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                          background:
                            "linear-gradient(135deg, #EA7C0A, #F59E0B)",
                          borderRadius: 10,
                          padding: "10px 16px",
                          marginTop: 16,
                          marginBottom: 8,
                          flexWrap: "wrap",
                          boxShadow: "0 4px 16px rgba(234,124,10,0.3)",
                        }}
                      >
                        <span
                          style={{
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: 14,
                          }}
                        >
                          {this.state.selectedOrderIds.length} order
                          {this.state.selectedOrderIds.length > 1
                            ? "s"
                            : ""}{" "}
                          selected
                        </span>
                        <span
                          style={{
                            color: "rgba(255,255,255,0.75)",
                            fontSize: 13,
                          }}
                        >
                          →
                        </span>
                        <span
                          style={{
                            background: "rgba(255,255,255,0.2)",
                            color: "#fff",
                            borderRadius: 6,
                            padding: "4px 12px",
                            fontSize: 13,
                            fontWeight: 700,
                          }}
                        >
                          {nextStatus}
                        </span>
                        <button
                          className="btn btn-sm"
                          style={{
                            background: "#fff",
                            color: "#EA7C0A",
                            fontWeight: 700,
                            fontSize: 13,
                            borderRadius: 6,
                            padding: "5px 18px",
                            marginLeft: 4,
                          }}
                          onClick={this.handleBulkStatusChange}
                          disabled={this.state.bulkLoading}
                        >
                          {this.state.bulkLoading ? (
                            <ClipLoader size={13} color="#EA7C0A" loading />
                          ) : (
                            "Move →"
                          )}
                        </button>
                        <button
                          className="btn btn-sm"
                          style={{
                            background: "rgba(255,255,255,0.15)",
                            color: "#fff",
                            fontSize: 13,
                            borderRadius: 6,
                            padding: "5px 14px",
                          }}
                          onClick={() =>
                            this.setState({ selectedOrderIds: [] })
                          }
                        >
                          Deselect All
                        </button>
                      </div>
                    );
                  })()}

                  <div
                    id="basicScenario"
                    className="product-physical"
                    style={{ marginTop: 12, overflowX: "auto" }}
                  >
                    <table
                      className="table table-bordered table-striped table-hover"
                      style={{ minWidth: 1100 }}
                    >
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            style={{
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "44px",
                              maxWidth: "44px",
                              textAlign: "center",
                              padding: "8px 4px",
                              fontSize: 12,
                            }}
                          >
                            <input
                              type="checkbox"
                              style={{
                                cursor: "pointer",
                                width: 15,
                                height: 15,
                              }}
                              checked={
                                renderableOrders.length > 0 &&
                                renderableOrders.every((o) =>
                                  this.state.selectedOrderIds.includes(o.id),
                                )
                              }
                              onChange={() =>
                                this.toggleSelectAll(renderableOrders)
                              }
                              title="Select all"
                            />
                          </th>
                          <th
                            scope="col"
                            style={{
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "110px",
                              maxWidth: "110px",
                              padding: "12px 8px",
                              fontSize: 12,
                            }}
                          >
                            Order Id
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "12px 8px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "220px",
                              maxWidth: "220px",
                              minWidth: "220px",
                              fontSize: 12,
                            }}
                          >
                            Customer
                          </th>
                          <th
                            scope="col"
                            style={{
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "140px",
                              minWidth: "140px",
                              padding: "12px 8px",
                              fontSize: 12,
                            }}
                          >
                            Products
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "12px 8px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "90px",
                              fontSize: 12,
                              whiteSpace: "nowrap",
                            }}
                          >
                            Total
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "12px 6px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "90px",
                              fontSize: 12,
                              whiteSpace: "nowrap",
                            }}
                          >
                            Status
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "12px 6px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "90px",
                              fontSize: 12,
                              whiteSpace: "nowrap",
                            }}
                          >
                            Payment
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "12px 6px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "100px",
                              fontSize: 12,
                            }}
                          >
                            Courier
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "12px 6px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "130px",
                              fontSize: 12,
                            }}
                          >
                            Invoice
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "12px 6px",
                              color: "white",
                              backgroundColor: "rgb(251, 148, 4)",
                              width: "80px",
                              fontSize: 12,
                            }}
                          >
                            <div
                              data-toggle="modal"
                              data-target="#receiveModal"
                            >
                              Action
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderableOrders.map((order, index) => (
                          <tr
                            key={index}
                            style={{
                              background: this.state.selectedOrderIds.includes(
                                order.id,
                              )
                                ? "#EEF2FF"
                                : undefined,
                            }}
                          >
                            <th
                              scope="row"
                              style={{
                                width: "44px",
                                maxWidth: "44px",
                                textAlign: "center",
                                padding: "8px 4px",
                                fontSize: 11,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 3,
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    cursor: "pointer",
                                    width: 14,
                                    height: 14,
                                  }}
                                  checked={this.state.selectedOrderIds.includes(
                                    order.id,
                                  )}
                                  onChange={() =>
                                    this.toggleSelectOrder(order.id)
                                  }
                                />
                                <span
                                  style={{ color: "#94a3b8", fontSize: 10 }}
                                >
                                  {index + 1}
                                </span>
                              </div>
                            </th>
                            <td
                              scope="row"
                              style={{
                                width: "110px",
                                maxWidth: "110px",
                                textAlign: "left",
                                padding: "8px",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {order.id}
                              </div>
                              <div style={{ marginTop: 5, fontSize: 13 }}>
                                {new Date(
                                  Number(order.date),
                                ).toLocaleDateString()}
                              </div>
                              <div style={{ marginTop: 5, fontSize: 13 }}>
                                at{" "}
                                {new Date(
                                  Number(order.date),
                                ).toLocaleTimeString()}
                              </div>
                            </td>

                            <td
                              style={{
                                width: "220px",
                                maxWidth: "220px",
                                minWidth: "220px",
                                textAlign: "left",
                                padding: "8px",
                              }}
                            >
                              <div
                                style={{
                                  background: "#FAF7F2",
                                  border: "1.5px solid #E8DFD0",
                                  borderRadius: 8,
                                  padding: "10px 12px",
                                  boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                                }}
                              >
                                <div
                                  style={{ fontWeight: "bold", fontSize: 13 }}
                                >
                                  {order.currentUser.displayName || "Guest"}
                                </div>
                                <div
                                  style={{
                                    fontSize: 12,
                                    marginTop: 5,
                                    display: "flex",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  <div>👤</div>{" "}
                                  <div style={{ marginLeft: 2 }}>
                                    {this.getDeliveryAddress(order)?.fullName}
                                  </div>
                                </div>
                                <div style={{ fontSize: 12, marginTop: 5 }}>
                                  📞 {this.getDeliveryAddress(order)?.mobileNo}
                                </div>
                                <div
                                  style={{
                                    fontSize: 12,
                                    marginTop: 5,
                                    display: "flex",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  <div>🌐 </div>
                                  <div
                                    style={{
                                      marginLeft: 3,
                                      lineHeight: "15px",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 5,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {this.getDeliveryAddress(order)?.address},{" "}
                                    <br />
                                    {this.getDeliveryAddress(order)?.district},
                                    {this.getDeliveryAddress(order)?.division}
                                  </div>
                                </div>
                                {order.orderNote && (
                                  <div
                                    style={{
                                      marginTop: 8,
                                      fontSize: 11,
                                      fontWeight: "bold",
                                      color: "#7C3AED",
                                      borderTop: "1px solid #f0f0f0",
                                      paddingTop: 6,
                                    }}
                                  >
                                    Note: {order.orderNote}
                                  </div>
                                )}
                              </div>
                            </td>

                            <td
                              data-toggle="modal"
                              data-target="#detailInfoModal"
                              onClick={() => {
                                this.onClick(order);
                              }}
                              style={{
                                width: "140px",
                                maxWidth: "140px",
                                padding: "8px",
                              }}
                            >
                              {order.orders &&
                                order.orders.length > 0 &&
                                (() => {
                                  const visible = order.orders.slice(0, 2);
                                  const extra =
                                    order.orders.length - visible.length;
                                  return (
                                    <div
                                      style={{
                                        background: "#fff",
                                        border: "1px solid #e2e8f0",
                                        borderRadius: 8,
                                        padding: "8px 10px",
                                        cursor: "pointer",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                                        transition:
                                          "box-shadow 0.15s, border-color 0.15s",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow =
                                          "0 4px 12px rgba(109,40,217,0.13)";
                                        e.currentTarget.style.borderColor =
                                          "#a78bfa";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow =
                                          "0 1px 3px rgba(0,0,0,0.06)";
                                        e.currentTarget.style.borderColor =
                                          "#e2e8f0";
                                      }}
                                    >
                                      {visible.map((item, i) => {
                                        const img =
                                          item.image ||
                                          item.productImage ||
                                          (item.selectedVariation &&
                                          item.selectedVariation.pictures &&
                                          item.selectedVariation.pictures
                                            .length > 0
                                            ? item.selectedVariation.pictures[0]
                                            : item.product &&
                                              item.product.pictures &&
                                              item.product.pictures[0]);
                                        const name =
                                          item.name ||
                                          (item.product && item.product.name);
                                        return (
                                          <div
                                            key={i}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 7,
                                              marginBottom:
                                                i < visible.length - 1 ? 6 : 0,
                                            }}
                                          >
                                            {img ? (
                                              <img
                                                src={img}
                                                alt=""
                                                referrerPolicy="no-referrer"
                                                onError={(e) => {
                                                  e.target.style.display =
                                                    "none";
                                                  e.target.nextSibling.style.display =
                                                    "flex";
                                                }}
                                                style={{
                                                  width: 34,
                                                  height: 34,
                                                  borderRadius: 5,
                                                  objectFit: "cover",
                                                  border: "1px solid #e0e0e0",
                                                  flexShrink: 0,
                                                }}
                                              />
                                            ) : null}
                                            <div
                                              style={{
                                                width: 34,
                                                height: 34,
                                                borderRadius: 5,
                                                background: "#F1F5F9",
                                                border: "1px solid #E2E8F0",
                                                flexShrink: 0,
                                                display: img ? "none" : "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: 14,
                                                color: "#CBD5E1",
                                              }}
                                            >
                                              ▦
                                            </div>
                                            <div style={{ minWidth: 0 }}>
                                              <div
                                                style={{
                                                  fontSize: 11,
                                                  fontWeight: 600,
                                                  color: "#1e293b",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  maxWidth: 80,
                                                }}
                                              >
                                                {name}
                                              </div>
                                              <div
                                                style={{
                                                  fontSize: 10,
                                                  color: "#6b7280",
                                                }}
                                              >
                                                Qty: {item.quantity}
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                      {extra > 0 && (
                                        <div
                                          style={{
                                            fontSize: 10,
                                            color: "#94a3b8",
                                            fontWeight: 600,
                                            marginTop: 5,
                                          }}
                                        >
                                          +{extra} more item
                                          {extra > 1 ? "s" : ""}
                                        </div>
                                      )}
                                      <div
                                        style={{
                                          fontSize: 10,
                                          color: "#6D28D9",
                                          fontWeight: 600,
                                          marginTop: 6,
                                          paddingTop: 5,
                                          borderTop: "1px solid #e2e8f0",
                                        }}
                                      >
                                        View details →
                                      </div>
                                    </div>
                                  );
                                })()}
                            </td>

                            <td>
                              <div
                                style={{
                                  display: "inline-block",
                                  background: "#F0F9FF",
                                  color: "#0F172A",
                                  fontSize: 14,
                                  fontWeight: 800,
                                  padding: "3px 10px",
                                  borderRadius: 6,
                                  letterSpacing: "-0.3px",
                                }}
                              >
                                ৳{" "}
                                {order.subTotal +
                                  order.deliveryCharge -
                                  order.discountApplied -
                                  (order.couponApplied
                                    ? order.couponApplied.discount
                                    : 0) -
                                  (order.finalDiscount
                                    ? order.finalDiscount
                                    : 0)}
                              </div>
                              <div
                                style={{
                                  marginTop: 6,
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 3,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 5,
                                  }}
                                >
                                  <span
                                    style={{
                                      background: "#DCFCE7",
                                      color: "#166534",
                                      fontSize: 10,
                                      fontWeight: 700,
                                      padding: "1px 6px",
                                      borderRadius: 4,
                                      letterSpacing: 0.3,
                                    }}
                                  >
                                    PAID
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 12,
                                      color: "#334155",
                                      fontWeight: 600,
                                    }}
                                  >
                                    ৳ {this.getTotalPaid(order)}
                                  </span>
                                </div>
                                {this.getTotalDue(order) > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 5,
                                    }}
                                  >
                                    <span
                                      style={{
                                        background: "#FEE2E2",
                                        color: "#991B1B",
                                        fontSize: 10,
                                        fontWeight: 700,
                                        padding: "1px 6px",
                                        borderRadius: 4,
                                        letterSpacing: 0.3,
                                      }}
                                    >
                                      DUE
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 12,
                                        color: "#DC2626",
                                        fontWeight: 700,
                                      }}
                                    >
                                      ৳ {this.getTotalDue(order)}
                                    </span>
                                  </div>
                                )}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 5,
                                  }}
                                >
                                  <span
                                    style={{
                                      background: "#F1F5F9",
                                      color: "#475569",
                                      fontSize: 10,
                                      fontWeight: 700,
                                      padding: "1px 6px",
                                      borderRadius: 4,
                                      letterSpacing: 0.3,
                                    }}
                                  >
                                    COD
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 12,
                                      color: "#475569",
                                      fontWeight: 600,
                                    }}
                                  >
                                    ৳ {this.getTotalDue(order)}
                                  </span>
                                </div>
                                {order.refundedAmount != null && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 5,
                                      marginTop: 2,
                                    }}
                                  >
                                    <span
                                      style={{
                                        background: "#E0E7FF",
                                        color: "#3730A3",
                                        fontSize: 10,
                                        fontWeight: 700,
                                        padding: "1px 6px",
                                        borderRadius: 4,
                                        letterSpacing: 0.3,
                                      }}
                                    >
                                      REFUNDED
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 12,
                                        color: "#4338CA",
                                        fontWeight: 700,
                                      }}
                                    >
                                      ৳ {order.refundedAmount}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </td>

                            <td>
                              {(() => {
                                const sMap = {
                                  Processing: {
                                    bg: "#EEF2FF",
                                    color: "#4338CA",
                                    dot: "#818CF8",
                                  },
                                  Confirmed: {
                                    bg: "#FFFBEB",
                                    color: "#92400E",
                                    dot: "#F59E0B",
                                  },
                                  Packing: {
                                    bg: "#FFF7ED",
                                    color: "#C2410C",
                                    dot: "#FB923C",
                                  },
                                  "On the way": {
                                    bg: "#F0F9FF",
                                    color: "#0369A1",
                                    dot: "#38BDF8",
                                  },
                                  Delivered: {
                                    bg: "#F0FDF4",
                                    color: "#15803D",
                                    dot: "#4ADE80",
                                  },
                                  "Partial Delivered": {
                                    bg: "#FEF9C3",
                                    color: "#713F12",
                                    dot: "#EAB308",
                                  },
                                  Cancelled: {
                                    bg: "#FEF2F2",
                                    color: "#991B1B",
                                    dot: "#F87171",
                                  },
                                };
                                const s = sMap[order.orderStatus] || {
                                  bg: "#F8FAFC",
                                  color: "#475569",
                                  dot: "#94A3B8",
                                };
                                return (
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: 5,
                                      padding: "4px 10px",
                                      borderRadius: 20,
                                      background: s.bg,
                                      border: `1px solid ${s.dot}55`,
                                    }}
                                  >
                                    <span
                                      style={{
                                        width: 6,
                                        height: 6,
                                        borderRadius: "50%",
                                        background: s.dot,
                                        flexShrink: 0,
                                        display: "inline-block",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: 11,
                                        fontWeight: 700,
                                        color: s.color,
                                        letterSpacing: "0.03em",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {order.orderStatus}
                                    </span>
                                  </div>
                                );
                              })()}
                            </td>
                            <td>
                              {(() => {
                                const pMap = {
                                  Paid: {
                                    bg: "#F0FDF4",
                                    color: "#15803D",
                                    dot: "#4ADE80",
                                  },
                                  "Partially Paid": {
                                    bg: "#FFFBEB",
                                    color: "#92400E",
                                    dot: "#F59E0B",
                                  },
                                  "Not Paid": {
                                    bg: "#FEF2F2",
                                    color: "#991B1B",
                                    dot: "#F87171",
                                  },
                                  pending: {
                                    bg: "#FFFBEB",
                                    color: "#92400E",
                                    dot: "#F59E0B",
                                  },
                                  purchaseLater: {
                                    bg: "#F8FAFC",
                                    color: "#475569",
                                    dot: "#94A3B8",
                                  },
                                };
                                const ps =
                                  (order && order.paymentStatus) || "Not Paid";
                                const p = pMap[ps] || pMap["Not Paid"];
                                return (
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: 5,
                                      padding: "4px 10px",
                                      borderRadius: 20,
                                      background: p.bg,
                                      border: `1px solid ${p.dot}55`,
                                      cursor: "pointer",
                                    }}
                                    data-toggle="modal"
                                    data-target="#paymentModal"
                                    onClick={() => this.onClick(order)}
                                  >
                                    <span
                                      style={{
                                        width: 6,
                                        height: 6,
                                        borderRadius: "50%",
                                        background: p.dot,
                                        flexShrink: 0,
                                        display: "inline-block",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: 11,
                                        fontWeight: 700,
                                        color: p.color,
                                        letterSpacing: "0.03em",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {ps}
                                    </span>
                                  </div>
                                );
                              })()}
                            </td>
                            {order.orderStatus !== "Packing" &&
                            order.orderStatus !== "On the way" &&
                            order.orderStatus !== "Delivered" &&
                            order.orderStatus !== "Partial Delivered" ? (
                              <td></td>
                            ) : (
                              <td>
                                {order.courier && order.courier.pathao ? (
                                  <div
                                    style={{
                                      display: "inline",
                                      padding: "2px 7px",
                                      borderRadius: 4,
                                      color: "white",
                                      background:
                                        "linear-gradient(135deg, #C2185B, #EC4899)",
                                      cursor: "pointer",
                                      fontSize: 11,
                                    }}
                                    data-toggle="modal"
                                    data-target="#courierModal"
                                    onClick={async () => {
                                      let baseUrl = ``;
                                      axios
                                        .get(`${baseUrl}/api/issue-token`, {
                                          headers: {
                                            "Content-Type": "application/json",
                                          },
                                        })
                                        .then((response) => {
                                          console.log(
                                            "Token Issued:",
                                            response,
                                          );
                                          if (response.status == 200) {
                                            // upon getting success access_token get the city list and zone list
                                            let access_token =
                                              response.data.access_token;
                                            this.setState({
                                              access_token,
                                            });
                                            axios
                                              .get(
                                                `${baseUrl}/api/order-info/${order.courier.consignment_id}`,
                                                {
                                                  headers: {
                                                    "Content-Type":
                                                      "application/json",
                                                    Authorization: `Bearer ${access_token}`,
                                                  },
                                                },
                                              )
                                              .then((response) => {
                                                console.log(response.data);
                                                this.setState({
                                                  orderObj: {
                                                    ...order,
                                                    deliveryStatus:
                                                      response.data &&
                                                      response.data.data
                                                        .order_status
                                                        ? response.data.data
                                                            .order_status
                                                        : "",
                                                    deliveryStatusDescription: `Your Order is ${response.data.data.order_status}`,
                                                  },
                                                  orderStatus:
                                                    order.orderStatus,
                                                  courier: "Pathao",
                                                });
                                              })
                                              .catch((error) => {
                                                notifyError(
                                                  "Error getting order Info.",
                                                );
                                              });
                                          }
                                        })
                                        .catch((error) => {
                                          notifyError(
                                            "Error getting access token",
                                          );
                                        });
                                    }}
                                  >
                                    Pathao
                                  </div>
                                ) : order.courier &&
                                  order.courier.consignment &&
                                  order.courier.consignment.consignment_id ? (
                                  <div>
                                    <div
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        padding: "4px 10px",
                                        borderRadius: 8,
                                        background: "#F0FDF4",
                                        border: "1px solid #BBF7D0",
                                        color: "#15803D",
                                        cursor: "pointer",
                                        fontSize: 11,
                                        fontWeight: 700,
                                        letterSpacing: "0.03em",
                                      }}
                                      data-toggle="modal"
                                      data-target="#courierModal"
                                      onClick={async () => {
                                        await this.onClick(order);
                                        const response = await axios.get(
                                          `${base_url}/status_by_cid/${order.courier.consignment.consignment_id}`,
                                          {
                                            headers: {
                                              "Api-Key": api_key,
                                              "Secret-Key": secret_key,
                                              "Content-Type":
                                                "application/json",
                                            },
                                          },
                                        );
                                        console.log(response.data);
                                        let description = "";
                                        if (
                                          response.data &&
                                          response.data.delivery_status
                                        ) {
                                          if (
                                            response.data.delivery_status ==
                                            "pending"
                                          ) {
                                            description =
                                              "Consignment is not delivered or cancelled yet.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "delivered_approval_pending"
                                          ) {
                                            description =
                                              "Consignment is delivered but waiting for admin approval.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "partial_delivered_approval_pending"
                                          ) {
                                            description =
                                              "Consignment is delivered partially and waiting for admin approval.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "cancelled_approval_pending"
                                          ) {
                                            description =
                                              "Consignment is cancelled and waiting for admin approval.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "unknown_approval_pending"
                                          ) {
                                            description =
                                              "Unknown Pending status. Need contact with the support team.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "delivered"
                                          ) {
                                            description =
                                              "Consignment is delivered and balance added.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "partial_delivered"
                                          ) {
                                            description =
                                              "Consignment is partially delivered and balance added.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "cancelled"
                                          ) {
                                            description =
                                              "Consignment is cancelled and balance updated.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "hold"
                                          ) {
                                            description =
                                              "Consignment is held.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "in_review"
                                          ) {
                                            description =
                                              "Order is placed and waiting to be reviewed.";
                                          } else if (
                                            response.data.delivery_status ==
                                            "unknown"
                                          ) {
                                            description =
                                              "Unknown status. Need contact with the support team.";
                                          }
                                        }
                                        this.setState({
                                          orderObj: {
                                            ...this.state.orderObj,
                                            deliveryStatus:
                                              response.data &&
                                              response.data.delivery_status
                                                ? response.data.delivery_status
                                                : "",
                                            deliveryStatusDescription:
                                              description,
                                          },
                                          orderStatus: order.orderStatus,
                                          courier: "SteadFast",
                                        });
                                      }}
                                    >
                                      SteadFast
                                    </div>
                                    <div
                                      style={{
                                        display: "block",
                                        marginTop: 8,
                                        fontSize: 13,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      ID:
                                      {order.courier.consignment.consignment_id}
                                    </div>
                                    {/* <div
                                      style={{
                                        display: "block",
                                        marginTop: 8,
                                        fontSize: 13,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Status:
                                      <span>
                                        {order.courier.consignment.status}
                                      </span>
                                    </div> */}
                                  </div>
                                ) : order && order.courier ? (
                                  <div
                                    style={{
                                      display: "inline",
                                      padding: "2px 7px",
                                      borderRadius: 4,
                                      color: "white",
                                      background:
                                        "linear-gradient(135deg, #DC2626, #EF4444)",
                                      cursor: "pointer",
                                      fontSize: 13,
                                    }}
                                  >
                                    Cancelled
                                  </div>
                                ) : (
                                  <>
                                    <img
                                      onClick={async () => {
                                        this.setState({
                                          orderStatus: order.orderStatus,
                                        });
                                        await this.handleSteadfastClick(order);
                                      }}
                                      src={SteadFast}
                                      style={{
                                        width: "80%",
                                        border: "1.5px solid #BBF7D0",
                                        borderRadius: 6,
                                        cursor: "pointer",
                                      }}
                                    />{" "}
                                    <br />
                                    <img
                                      data-toggle="modal"
                                      data-target="#courierModal"
                                      onClick={async () => {
                                        await this.onClick(order);
                                        let baseUrl = ``;
                                        axios
                                          .get(`${baseUrl}/api/issue-token`, {
                                            headers: {
                                              "Content-Type":
                                                "application/json",
                                            },
                                          })
                                          .then((response) => {
                                            console.log(
                                              "Token Issued:",
                                              response,
                                            );
                                            if (response.status == 200) {
                                              // upon getting success access_token get the city list and zone list
                                              let access_token =
                                                response.data.access_token;
                                              this.setState({
                                                access_token,
                                              });
                                              axios
                                                .get(
                                                  `${baseUrl}/api/city-list`,
                                                  {
                                                    headers: {
                                                      "Content-Type":
                                                        "application/json",
                                                      Authorization: `Bearer ${access_token}`,
                                                    },
                                                  },
                                                )
                                                .then((response) => {
                                                  //  upon getting city lists find the actual city.

                                                  this.setState(
                                                    {
                                                      cityList:
                                                        response.data.data.data,
                                                    },
                                                    () => {
                                                      console.log(
                                                        this.state.cityList,
                                                      );
                                                    },
                                                  );
                                                })
                                                .catch((error) => {
                                                  notifyError(
                                                    error.message ||
                                                      String(error),
                                                  );
                                                });
                                            }
                                          })
                                          .catch((error) => {
                                            notifyError(
                                              "Error creating access token. ",
                                            );
                                            console.error(
                                              "Error:",
                                              error.response
                                                ? error.response.data
                                                : error.message,
                                            );
                                          });
                                        this.setState({
                                          orderStatus: order.orderStatus,
                                          courier: "Pathao",
                                          note: "",
                                          weight: "",
                                          city: null,
                                          cityList: [],
                                          areaList: [],
                                          cityObject: null,
                                          zoneObject: null,
                                          zone: null,
                                        });
                                      }}
                                      src={Pathao}
                                      style={{
                                        width: "80%",
                                        border: "2px solid #ec345b",
                                        borderRadius: 5,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </>
                                )}
                              </td>
                            )}
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  gap: 5,
                                }}
                              >
                                <a
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 4,
                                    padding: "5px 11px",
                                    borderRadius: 8,
                                    background: "#F0F9FF",
                                    border: "1px solid #BAE6FD",
                                    color: "#0369A1",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    cursor: "pointer",
                                    textDecoration: "none",
                                    letterSpacing: "0.03em",
                                  }}
                                  href={`https://zapai.com.bd/invoice?orderId=${order.id}`}
                                  target="_blank"
                                >
                                  ↗ Invoice
                                </a>
                                {this.props.currentAdmin &&
                                  this.props.currentAdmin.status !=
                                    "Employee" && (
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 4,
                                        padding: "5px 11px",
                                        borderRadius: 8,
                                        background: "#FFFBEB",
                                        border: "1px solid #FDE68A",
                                        color: "#92400E",
                                        fontSize: 11,
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        letterSpacing: "0.03em",
                                      }}
                                      data-toggle="modal"
                                      data-target="#personalInfoModal2"
                                      onClick={async () => {
                                        await this.onClick(order);
                                        this.setState({
                                          orderStatus: order.orderStatus,
                                        });
                                      }}
                                    >
                                      ✎ Edit
                                    </span>
                                  )}
                              </div>
                            </td>

                            {order && order.orderStatus == "Delivered" ? (
                              ""
                            ) : (
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 5,
                                  }}
                                >
                                  <div
                                    data-toggle="modal"
                                    data-target="#personalInfoModal"
                                    onClick={async () => {
                                      await this.onClick(order);
                                      this.setState({
                                        orderStatus: order.orderStatus,
                                      });
                                    }}
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: 4,
                                      padding: "5px 10px",
                                      borderRadius: 8,
                                      background: "#F0FDF4",
                                      border: "1px solid #BBF7D0",
                                      color: "#15803D",
                                      fontSize: 11,
                                      fontWeight: 700,
                                      cursor: "pointer",
                                      letterSpacing: "0.03em",
                                    }}
                                  >
                                    ↑ Status
                                  </div>
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: 4,
                                      padding: "5px 10px",
                                      borderRadius: 8,
                                      background: "#EFF6FF",
                                      border: "1px solid #BFDBFE",
                                      color: "#1D4ED8",
                                      fontSize: 11,
                                      fontWeight: 700,
                                      cursor: "pointer",
                                      letterSpacing: "0.03em",
                                    }}
                                    onClick={async () => {
                                      await this.onClick(order);
                                      this.setState(
                                        { orderObj: this.state.orderObj },
                                        () => {
                                          this.reactToPrintTrigger.handlePrint();
                                        },
                                      );
                                    }}
                                  >
                                    ⎙ Print
                                  </div>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
        <div
          className="modal fade"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "100%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Update Status
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {orderObj && (
                <div className="modal-body">
                  <div style={{ padding: "10px 15px" }}>
                    <div className="form-group">
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Status
                      </label>
                      <select
                        title="Please choose a package"
                        required
                        name="orderStatus"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.orderStatus}
                        style={{
                          lineHeight: "normal",
                          height: "auto",
                          paddingTop: 8,
                          paddingBottom: 8,
                        }}
                      >
                        <option value="">Select Status</option>
                        <option value="Processing">Processing</option>
                        <option
                          value="Confirmed"
                          disabled={orderObj.date ? false : true}
                        >
                          Confirmed
                        </option>
                        <option
                          value="Packing"
                          disabled={orderObj.confirmedDate ? false : true}
                        >
                          Packing
                        </option>
                        <option
                          value="On the way"
                          disabled={orderObj.packingDate ? false : true}
                        >
                          On the way
                        </option>
                        <option
                          value="Delivered"
                          disabled={orderObj["on the wayDate"] ? false : true}
                        >
                          Delivered
                        </option>
                        <option
                          value="Partial Delivered"
                          disabled={orderObj["on the wayDate"] ? false : true}
                        >
                          Partial Delivered
                        </option>
                        <option value="Cancelled"> Cancelled</option>
                      </select>
                    </div>

                    {this.state.orderStatus == "Cancelled" && (
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Cancellation note
                        </label>
                        <textarea
                          type="text"
                          name="cancelNote"
                          className="form-control"
                          placeholder="Enter Cancellation Note"
                          style={{ fontSize: "1rem" }}
                          onChange={this.handleChange}
                          value={this.state.cancelNote}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    background: "linear-gradient(135deg, #4F46E5, #7C3AED)",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="personalInfoModal2"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "100%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Edit Order
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {orderObj && (
                <div className="modal-body">
                  <div style={{ padding: "10px 15px" }}>
                    {orderObj && (
                      <section className="flat-spacing-11">
                        <div className="tf-page-cart-wrap">
                          <div className="tf-page-cart-item">
                            <form onSubmit={(e) => e.preventDefault()}>
                              {orderObj.orders.map((item, i) => (
                                <div
                                  key={i}
                                  className="tf-cart-item file-delete"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    marginBottom: 10,
                                    paddingBottom: 10,
                                    borderBottom: "1px solid gainsboro",
                                  }}
                                >
                                  <div
                                    className="tf-cart-item_product"
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "flex-start",
                                    }}
                                  >
                                    <div className="img-box fixed-width-height">
                                      <img
                                        alt="img-product"
                                        src={
                                          item.productImage ||
                                          (item.selectedVariation &&
                                          item.selectedVariation?.id &&
                                          item.selectedVariation.pictures &&
                                          item.selectedVariation.pictures
                                            .length > 0
                                            ? item.selectedVariation.pictures[0]
                                            : item.product &&
                                              item.product.pictures &&
                                              item.product.pictures[0])
                                        }
                                        referrerPolicy="no-referrer"
                                        style={{
                                          objectFit: "cover",
                                          borderRadius: 5,
                                          border: "1px solid gainsboro",
                                          maxHeight: 70,
                                          minHeight: 70,
                                          maxWidth: 70,
                                          minWidth: 70,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className="cart-info"
                                      style={{ marginLeft: 5 }}
                                    >
                                      <div className="cart-title link">
                                        <div
                                          style={{
                                            fontWeight: "bold",
                                            fontSize: 13,
                                          }}
                                        >
                                          {item.product.name.slice(0, 40)}
                                        </div>
                                      </div>
                                      <div
                                        className="cart-meta-variant"
                                        style={{
                                          fontSize: 13,
                                          marginTop: 5,
                                        }}
                                      >
                                        {item.selectedVariation &&
                                          item.selectedVariation?.id &&
                                          item.selectedVariation.combination.map(
                                            (comb, index) => (
                                              <div
                                                key={index}
                                                style={{
                                                  marginTop: -5,
                                                }}
                                              >
                                                {item.product.savedAttributes.find(
                                                  (attr) =>
                                                    attr.id == comb.parentId,
                                                )
                                                  ? item.product.savedAttributes.find(
                                                      (attr) =>
                                                        attr.id ==
                                                        comb.parentId,
                                                    ).name
                                                  : ""}
                                                :{" "}
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: 13,
                                                  }}
                                                >
                                                  {comb.name}
                                                </span>
                                              </div>
                                            ),
                                          )}
                                      </div>
                                      <div
                                        className="tf-cart-item_quantity"
                                        cart-data-title="Quantity"
                                      >
                                        <div className="cart-quantity">
                                          <div
                                            className="wg-quantity"
                                            style={{ marginBottom: 10 }}
                                          >
                                            <span
                                              className="btn-quantity minus-btn"
                                              onClick={() => {
                                                let orders =
                                                  orderObj.orders.map(
                                                    (cartItem) => {
                                                      if (
                                                        item.selectedVariation &&
                                                        item.selectedVariation
                                                          .id
                                                      ) {
                                                        if (
                                                          cartItem.selectedVariation &&
                                                          cartItem
                                                            .selectedVariation
                                                            .id ==
                                                            item
                                                              .selectedVariation
                                                              .id
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              cartItem.quantity >
                                                              1
                                                                ? parseInt(
                                                                    cartItem.quantity,
                                                                  ) - 1
                                                                : 1,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      } else {
                                                        if (
                                                          cartItem.productId ==
                                                          item.productId
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              cartItem.quantity >
                                                              1
                                                                ? parseInt(
                                                                    cartItem.quantity,
                                                                  ) - 1
                                                                : 1,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      }
                                                    },
                                                  );
                                                let { actualOrder, sumAmount } =
                                                  this.calculateCart(orders);
                                                console.log(actualOrder);
                                                console.log(sumAmount);
                                                this.setState({
                                                  orderObj: {
                                                    ...orderObj,
                                                    orders: orders,
                                                    discountApplied:
                                                      actualOrder - sumAmount,
                                                    subTotal: actualOrder,
                                                  },
                                                });
                                              }}
                                              style={{
                                                background:
                                                  "linear-gradient(135deg, #D97706, #F97316)",
                                                color: "white",
                                                padding: "4px 8px",
                                                borderBottomLeftRadius: 5,
                                                borderTopLeftRadius: 5,
                                              }}
                                            >
                                              <svg
                                                className="d-inline-block"
                                                width={9}
                                                height={9}
                                                viewBox="0 0 9 1"
                                                fill="currentColor"
                                              >
                                                <path d="M9 1H5.14286H3.85714H0V1.50201e-05H3.85714L5.14286 0L9 1.50201e-05V1Z" />
                                              </svg>
                                            </span>
                                            <input
                                              type="text"
                                              name="number"
                                              value={item.quantity}
                                              min={1}
                                              style={{
                                                maxWidth: 50,
                                                textAlign: "center",
                                                marginTop: 10,
                                                color: "gray",
                                                borderLeft: "none",
                                                borderRight: "none",
                                                padding: 2,
                                              }}
                                              onChange={(e) => {
                                                let orders =
                                                  orderObj.orders.map(
                                                    (cartItem) => {
                                                      if (
                                                        item.selectedVariation &&
                                                        item.selectedVariation
                                                          .id
                                                      ) {
                                                        if (
                                                          cartItem.selectedVariation &&
                                                          cartItem
                                                            .selectedVariation
                                                            .id ==
                                                            item
                                                              .selectedVariation
                                                              .id
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              e.target.value &&
                                                              e.target.value > 0
                                                                ? parseInt(
                                                                    e.target
                                                                      .value,
                                                                  )
                                                                : cartItem.quantity,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      } else {
                                                        if (
                                                          cartItem.productId ==
                                                          item.productId
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              e.target.value &&
                                                              e.target.value > 0
                                                                ? parseInt(
                                                                    e.target
                                                                      .value,
                                                                  )
                                                                : cartItem.quantity,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      }
                                                    },
                                                  );
                                                let { actualOrder, sumAmount } =
                                                  this.calculateCart(orders);
                                                console.log(actualOrder);
                                                console.log(sumAmount);
                                                this.setState({
                                                  orderObj: {
                                                    ...orderObj,
                                                    orders: orders,
                                                    discountApplied:
                                                      actualOrder - sumAmount,
                                                    subTotal: actualOrder,
                                                  },
                                                });
                                              }}
                                            />
                                            <span
                                              className="btn-quantity plus-btn"
                                              onClick={() => {
                                                let orders =
                                                  orderObj.orders.map(
                                                    (cartItem) => {
                                                      if (
                                                        item.selectedVariation &&
                                                        item.selectedVariation
                                                          .id
                                                      ) {
                                                        if (
                                                          cartItem.selectedVariation
                                                        ) {
                                                          if (
                                                            cartItem
                                                              .selectedVariation
                                                              .id ===
                                                            item
                                                              .selectedVariation
                                                              .id
                                                          ) {
                                                            console.log(
                                                              cartItem,
                                                            );

                                                            return {
                                                              ...cartItem,
                                                              quantity:
                                                                parseInt(
                                                                  cartItem.quantity,
                                                                ) + 1,
                                                            };
                                                          } else {
                                                            return cartItem;
                                                          }
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      } else {
                                                        if (
                                                          cartItem.productId ==
                                                          item.productId
                                                        ) {
                                                          return {
                                                            ...cartItem,
                                                            quantity:
                                                              parseInt(
                                                                cartItem.quantity,
                                                              ) + 1,
                                                          };
                                                        } else {
                                                          return cartItem;
                                                        }
                                                      }
                                                    },
                                                  );
                                                let { actualOrder, sumAmount } =
                                                  this.calculateCart(orders);
                                                console.log(actualOrder);
                                                console.log(sumAmount);
                                                this.setState({
                                                  orderObj: {
                                                    ...orderObj,
                                                    orders: orders,
                                                    discountApplied:
                                                      actualOrder - sumAmount,
                                                    subTotal: actualOrder,
                                                  },
                                                });
                                              }}
                                              style={{
                                                background:
                                                  "linear-gradient(135deg, #D97706, #F97316)",
                                                color: "white",
                                                padding: "4px 8px",
                                                borderBottomRightRadius: 5,
                                                borderTopRightRadius: 5,
                                              }}
                                            >
                                              <svg
                                                className="d-inline-block"
                                                width={9}
                                                height={9}
                                                viewBox="0 0 9 9"
                                                fill="currentColor"
                                              >
                                                <path d="M9 5.14286H5.14286V9H3.85714V5.14286H0V3.85714H3.85714V0H5.14286V3.85714H9V5.14286Z" />
                                              </svg>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <span
                                        className="remove-cart link remove"
                                        onClick={() => {
                                          let updatedOrderArray = [];
                                          console.log(orderObj);
                                          if (orderObj.orders.length == 1) {
                                            notifyWarning(
                                              "Order at least must have one item.",
                                            );
                                            return;
                                          }
                                          if (item.selectedVariation) {
                                            // Remove the item with the matching productId and selectedVariation
                                            const updatedOrder =
                                              orderObj.orders.filter(
                                                (order) =>
                                                  !(
                                                    order.productId ===
                                                      item.productId &&
                                                    order.selectedVariation
                                                      ?.id ===
                                                      item.selectedVariation?.id
                                                  ),
                                              );

                                            // Update localStorage

                                            updatedOrderArray = updatedOrder;
                                          } else {
                                            // Remove the item with the matching productId
                                            const updatedOrder =
                                              orderObj.orders.filter(
                                                (order) =>
                                                  order.productId !==
                                                  item.productId,
                                              );
                                            updatedOrderArray = updatedOrder;
                                          }
                                          console.log(updatedOrderArray);
                                          let { actualOrder, sumAmount } =
                                            this.calculateCart(
                                              updatedOrderArray,
                                            );
                                          console.log(sumAmount);
                                          this.setState(
                                            {
                                              orderObj: {
                                                ...this.state.orderObj,
                                                orders: updatedOrderArray,
                                                discountApplied:
                                                  actualOrder - sumAmount,
                                                subTotal: actualOrder,
                                              },
                                            },
                                            () => {
                                              console.log(this.state.orderObj);
                                            },
                                          );
                                        }}
                                        style={{
                                          textDecoration: "underline",
                                          fontSize: 13,
                                          cursor: "pointer",
                                        }}
                                      >
                                        Remove
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    className="tf-cart-item_price"
                                    cart-data-title="Price"
                                  >
                                    <div
                                      className="price fw-6"
                                      style={{
                                        textAlign: "center",
                                        marginTop: 3,
                                        fontSize: 14,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      ৳ {this.getPrice2(item)}
                                    </div>
                                    <div
                                      className="price fw-6"
                                      style={{
                                        textAlign: "center",
                                        textDecoration: "line-through",
                                        color: "gray",
                                        fontSize: 11,
                                      }}
                                    >
                                      {this.getPrice3(item)}
                                    </div>
                                    <div
                                      className="tf-cart-item_total"
                                      cart-data-title="Total"
                                      style={{ marginTop: 20 }}
                                    >
                                      <div
                                        className="cart-total"
                                        style={{
                                          minWidth: "60px",
                                          textAlign: "center",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        ৳{this.singleProductTotal(item)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                              {orderObj &&
                                orderObj.couponApplied &&
                                orderObj.couponApplied.name && (
                                  <div className="form-group">
                                    <span
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        name={""}
                                        checked={false}
                                        onChange={(e) => {
                                          this.setState({
                                            orderObj: {
                                              ...this.state.orderObj,
                                              couponApplied: e.target.checked
                                                ? null
                                                : orderObj.couponApplied,
                                            },
                                          });
                                        }}
                                        style={{
                                          height: 20,
                                          width: 20,
                                        }}
                                      />

                                      <div
                                        style={{
                                          marginLeft: 5,
                                          color: "black",
                                          fontWeight: "bold",
                                          marginTop: 2,
                                        }}
                                      >
                                        Remove Coupon
                                      </div>
                                    </span>
                                  </div>
                                )}
                              <div
                                className="form-group"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <label
                                  style={{
                                    fontWeight: "bold",
                                    color: "black",
                                    marginTop: 14,
                                  }}
                                >
                                  Update delivery charge
                                </label>
                                <input
                                  type="number"
                                  name="number"
                                  value={
                                    orderObj && orderObj.deliveryCharge > 0
                                      ? orderObj.deliveryCharge
                                      : ""
                                  }
                                  style={{
                                    textAlign: "center",
                                    marginTop: 10,
                                    color: "gray",
                                    padding: 2,
                                    paddingLeft: 5,
                                    border: "2px solid gray",
                                    borderRadius: 5,
                                  }}
                                  onChange={(e) => {
                                    // Ensure we update only if the input is a valid number
                                    if (e.target.value && e.target.value >= 0) {
                                      this.setState({
                                        orderObj: {
                                          ...orderObj,
                                          deliveryCharge:
                                            e.target.value === ""
                                              ? ""
                                              : parseInt(e.target.value), // If empty, don't set a value
                                        },
                                      });
                                    }
                                  }}
                                />
                              </div>
                              <div
                                className="form-group"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <label
                                  style={{
                                    fontWeight: "bold",
                                    color: "black",
                                    marginTop: 14,
                                  }}
                                >
                                  Final Discount
                                </label>
                                <input
                                  type="number"
                                  name="number"
                                  value={
                                    orderObj && orderObj.finalDiscount > 0
                                      ? orderObj.finalDiscount
                                      : ""
                                  }
                                  style={{
                                    textAlign: "center",
                                    marginTop: 10,
                                    color: "gray",
                                    padding: 2,
                                    paddingLeft: 5,
                                    border: "2px solid gray",
                                    borderRadius: 5,
                                  }}
                                  onChange={(e) => {
                                    // Ensure we update only if the input is a valid number
                                    if (e.target.value && e.target.value >= 0) {
                                      this.setState({
                                        orderObj: {
                                          ...orderObj,
                                          finalDiscount:
                                            e.target.value === ""
                                              ? ""
                                              : parseInt(e.target.value), // If empty, don't set a value
                                        },
                                      });
                                    }
                                  }}
                                />
                              </div>
                            </form>
                          </div>
                          {orderObj && (
                            <div className="tf-page-cart-footer">
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Delivery Charge{" "}
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {(orderObj && orderObj.deliveryCharge) || "0"}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Discount applied{" "}
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {(orderObj && orderObj.discountApplied) ||
                                    "0"}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Coupon applied{" "}
                                  <span
                                    style={{
                                      color: "#7C3AED",
                                      fontWeight: "bold",
                                      fontSize: 12,
                                    }}
                                  >
                                    {" "}
                                    (
                                    {orderObj.couponApplied &&
                                      orderObj.couponApplied.name}
                                    )
                                  </span>
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {(orderObj.couponApplied &&
                                    orderObj.couponApplied.discount) ||
                                    0}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Subtotal
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {parseInt(orderObj.subTotal) +
                                    orderObj.deliveryCharge -
                                    orderObj.discountApplied -
                                    (orderObj.couponApplied
                                      ? orderObj.couponApplied.discount
                                      : 0)}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Final Discount{" "}
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  - ৳{" "}
                                  {(orderObj.finalDiscount &&
                                    orderObj.finalDiscount) ||
                                    0}
                                </span>
                              </div>
                              <div
                                className="tf-cart-totals-discounts"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3
                                  style={{ fontWeight: "bold", color: "black" }}
                                >
                                  Payable Amount{" "}
                                  <span style={{ fontSize: 11 }}>
                                    (after discount)
                                  </span>
                                </h3>
                                <span
                                  className="total-value"
                                  style={{
                                    fontWeight: "bold",
                                    marginRight: 10,
                                  }}
                                >
                                  ৳{" "}
                                  {parseInt(orderObj.subTotal) +
                                    orderObj.deliveryCharge -
                                    orderObj.discountApplied -
                                    (orderObj.couponApplied
                                      ? orderObj.couponApplied.discount
                                      : 0) -
                                    (orderObj.finalDiscount
                                      ? orderObj.finalDiscount
                                      : 0)}
                                </span>
                              </div>
                              {orderObj.refundedAmount != null && (
                                <div
                                  className="tf-cart-totals-discounts"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <h3
                                    style={{
                                      fontWeight: "bold",
                                      color: "#3730A3",
                                    }}
                                  >
                                    Refunded Amount
                                  </h3>
                                  <span
                                    className="total-value"
                                    style={{
                                      fontWeight: "bold",
                                      marginRight: 10,
                                      color: "#3730A3",
                                    }}
                                  >
                                    ৳ {orderObj.refundedAmount}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </section>
                    )}
                  </div>
                </div>
              )}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    background: "linear-gradient(135deg, #4F46E5, #7C3AED)",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.updateOrder();
                  }}
                >
                  Update Order
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* ── Fraud Check Modal ─────────────────────────────────────── */}
        {this.state.fraudModalOpen &&
          (() => {
            const { fraudCheckLoading, fraudData, orderObj } = this.state;
            const phone = orderObj
              ? this.getDeliveryAddress(orderObj)?.mobileNo
              : "";
            const cancellationRate =
              fraudData && !fraudData.error && fraudData.total_parcels > 0
                ? Math.round(
                    (fraudData.total_cancelled / fraudData.total_parcels) * 100,
                  )
                : 0;
            const hasFraudReports =
              fraudData &&
              !fraudData.error &&
              fraudData.total_fraud_reports &&
              fraudData.total_fraud_reports.length > 0;
            const isHighRisk = cancellationRate >= 60 || hasFraudReports;

            return (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "rgba(15,10,42,0.65)",
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backdropFilter: "blur(2px)",
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: 16,
                    width: "100%",
                    maxWidth: 460,
                    margin: "0 16px",
                    overflow: "hidden",
                    boxShadow: "0 24px 64px rgba(15,10,42,0.22)",
                    animation: "fraudSlideIn 0.25s ease",
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      background: fraudCheckLoading
                        ? "linear-gradient(135deg, #4F46E5, #7C3AED)"
                        : isHighRisk
                          ? "linear-gradient(135deg, #DC2626, #EF4444)"
                          : "linear-gradient(135deg, #059669, #10B981)",
                      padding: "18px 22px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      transition: "background 0.4s ease",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          color: "rgba(255,255,255,0.75)",
                          fontSize: 11,
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: 1,
                          marginBottom: 3,
                        }}
                      >
                        Steadfast Fraud Check
                      </div>
                      <div
                        style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}
                      >
                        {phone || "Customer"}
                      </div>
                    </div>
                    <button
                      onClick={() => this.setState({ fraudModalOpen: false })}
                      style={{
                        background: "rgba(255,255,255,0.18)",
                        border: "none",
                        borderRadius: 8,
                        width: 32,
                        height: 32,
                        cursor: "pointer",
                        color: "#fff",
                        fontSize: 18,
                        lineHeight: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      &times;
                    </button>
                  </div>

                  {/* Body */}
                  <div style={{ padding: "24px 22px" }}>
                    {fraudCheckLoading ? (
                      <div style={{ textAlign: "center", padding: "32px 0" }}>
                        <div style={{ marginBottom: 16 }}>
                          <ClipLoader size={36} color="#6D28D9" loading />
                        </div>
                        <div style={{ color: "#6b7280", fontSize: 14 }}>
                          Checking customer history…
                        </div>
                      </div>
                    ) : fraudData && fraudData.error ? (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "24px 0",
                          color: "#DC2626",
                          fontSize: 14,
                        }}
                      >
                        Could not fetch fraud data. You can still proceed.
                      </div>
                    ) : fraudData ? (
                      <>
                        {/* Stat cards */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 12,
                            marginBottom: 18,
                          }}
                        >
                          {[
                            {
                              label: "Total Orders",
                              value: fraudData.total_parcels,
                              color: "#4F46E5",
                              bg: "#EEF2FF",
                              border: "#C7D2FE",
                            },
                            {
                              label: "Delivered",
                              value: fraudData.total_delivered,
                              color: "#059669",
                              bg: "#ECFDF5",
                              border: "#6EE7B7",
                            },
                            {
                              label: "Cancelled",
                              value: fraudData.total_cancelled,
                              color: "#DC2626",
                              bg: "#FEF2F2",
                              border: "#FCA5A5",
                            },
                            {
                              label: "Cancel Rate",
                              value: `${cancellationRate}%`,
                              color:
                                cancellationRate >= 60
                                  ? "#DC2626"
                                  : cancellationRate >= 30
                                    ? "#D97706"
                                    : "#059669",
                              bg:
                                cancellationRate >= 60
                                  ? "#FEF2F2"
                                  : cancellationRate >= 30
                                    ? "#FFFBEB"
                                    : "#ECFDF5",
                              border:
                                cancellationRate >= 60
                                  ? "#FCA5A5"
                                  : cancellationRate >= 30
                                    ? "#FCD34D"
                                    : "#6EE7B7",
                            },
                          ].map((card) => (
                            <div
                              key={card.label}
                              style={{
                                background: card.bg,
                                border: `1.5px solid ${card.border}`,
                                borderRadius: 10,
                                padding: "14px 16px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 11,
                                  fontWeight: 700,
                                  color: card.color,
                                  textTransform: "uppercase",
                                  letterSpacing: 0.5,
                                  marginBottom: 6,
                                }}
                              >
                                {card.label}
                              </div>
                              <div
                                style={{
                                  fontSize: 26,
                                  fontWeight: 800,
                                  color: card.color,
                                  lineHeight: 1,
                                }}
                              >
                                {card.value}
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Fraud reports */}
                        {hasFraudReports ? (
                          <div
                            style={{
                              background: "#FEF2F2",
                              border: "1.5px solid #FCA5A5",
                              borderRadius: 10,
                              padding: "12px 14px",
                              marginBottom: 18,
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 700,
                                color: "#DC2626",
                                fontSize: 12,
                                textTransform: "uppercase",
                                letterSpacing: 0.5,
                                marginBottom: 8,
                              }}
                            >
                              ⚠ {fraudData.total_fraud_reports.length} Fraud
                              Report
                              {fraudData.total_fraud_reports.length > 1
                                ? "s"
                                : ""}
                            </div>
                            {fraudData.total_fraud_reports.map((r, i) => (
                              <div
                                key={i}
                                style={{
                                  fontSize: 13,
                                  color: "#7f1d1d",
                                  padding: "4px 0",
                                  borderBottom:
                                    i < fraudData.total_fraud_reports.length - 1
                                      ? "1px solid #FECACA"
                                      : "none",
                                }}
                              >
                                {typeof r === "string" ? r : JSON.stringify(r)}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div
                            style={{
                              background: "#ECFDF5",
                              border: "1.5px solid #6EE7B7",
                              borderRadius: 10,
                              padding: "10px 14px",
                              marginBottom: 18,
                              fontSize: 13,
                              color: "#065F46",
                              fontWeight: 600,
                            }}
                          >
                            ✓ No fraud reports found
                          </div>
                        )}

                        {/* Risk label */}
                        {isHighRisk && (
                          <div
                            style={{
                              background: "#FEF2F2",
                              border: "1.5px solid #FCA5A5",
                              borderRadius: 8,
                              padding: "8px 14px",
                              marginBottom: 14,
                              fontSize: 13,
                              color: "#DC2626",
                              fontWeight: 600,
                            }}
                          >
                            ⚠ High cancellation rate or fraud report detected.
                            Proceed with caution.
                          </div>
                        )}
                      </>
                    ) : null}
                  </div>

                  {/* Footer */}
                  {!fraudCheckLoading && (
                    <div
                      style={{
                        padding: "0 22px 20px",
                        display: "flex",
                        gap: 10,
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        onClick={() => this.setState({ fraudModalOpen: false })}
                        style={{
                          background: "#f1f5f9",
                          border: "none",
                          borderRadius: 8,
                          padding: "9px 20px",
                          fontSize: 13,
                          color: "#475569",
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={this.handleFraudProceed}
                        style={{
                          background:
                            "linear-gradient(135deg, #4F46E5, #7C3AED)",
                          border: "none",
                          borderRadius: 8,
                          padding: "9px 22px",
                          fontSize: 13,
                          color: "#fff",
                          fontWeight: 700,
                          cursor: "pointer",
                        }}
                      >
                        Proceed to Book →
                      </button>
                    </div>
                  )}
                </div>
                <style>{`
                @keyframes fraudSlideIn {
                  from { opacity: 0; transform: translateY(-20px) scale(0.97); }
                  to   { opacity: 1; transform: translateY(0)   scale(1);    }
                }
              `}</style>
              </div>
            );
          })()}

        <div
          className="modal fade"
          id="courierModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "100%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  {orderObj &&
                  orderObj.courier &&
                  orderObj.courier.pathao &&
                  orderObj.courier.consignment_id
                    ? "Consignment has been created at pathao"
                    : orderObj &&
                        orderObj.courier &&
                        orderObj.courier.status == 200
                      ? "Consignment has been created at steadFast"
                      : orderObj &&
                          orderObj.courier &&
                          orderObj.courier.status != 200
                        ? "An error occurred creating the consignment."
                        : "Select Courier"}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close-btn-courier"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {orderObj && (
                <div className="modal-body">
                  <div style={{ padding: "10px 15px" }}>
                    <div className="form-group">
                      {!orderObj.courier && (
                        <div>
                          Are you sure you want to deliver this order with{" "}
                          {this.state.courier}?
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          marginTop: 20,
                        }}
                      >
                        <div style={{ fontWeight: "bold", marginTop: 10 }}>
                          {" "}
                          Selected Courier:{" "}
                        </div>
                        <img
                          src={
                            this.state.courier == "SteadFast"
                              ? SteadFast
                              : Pathao
                          }
                          style={{
                            width: 100,
                            marginLeft: 6,
                            border:
                              this.state.courier == "SteadFast"
                                ? "2px solid #319f82"
                                : "2px solid #e83234",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      {!orderObj.courier && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            marginTop: 20,
                          }}
                        >
                          <div style={{ minWidth: "100%" }}>
                            {this.state.courier === "Pathao" && (
                              <>
                                <div
                                  // className="form-group"
                                  style={{ minWidth: "100%" }}
                                >
                                  <div style={{ fontWeight: "bold" }}>
                                    Total Weight (in kg)
                                  </div>
                                  <input
                                    name="weight"
                                    value={this.state.weight}
                                    style={{
                                      width: "100%",
                                      borderRadius: 5,
                                      textAlign: "left",
                                      marginTop: 5,
                                      padding: 10,
                                    }}
                                    type="number"
                                    placeholder="Enter Product weight (in kg)"
                                    onChange={(e) => {
                                      this.setState({
                                        weight: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                                <div
                                  // className="form-group"
                                  style={{ minWidth: "100%", marginTop: 15 }}
                                >
                                  <div style={{ fontWeight: "bold" }}>
                                    Select City
                                  </div>
                                  <select
                                    title=""
                                    name="city"
                                    className="custom-select"
                                    aria-required="true"
                                    aria-invalid="false"
                                    onChange={async (e) => {
                                      const { name, value } = e.target;
                                      let cityObject = this.state.cityList.find(
                                        (city) => city.city_name == value,
                                      );
                                      console.log(this.state.cityList);
                                      console.log(value);
                                      console.log(cityObject);
                                      this.setState(
                                        {
                                          [name]: value,
                                          cityObject: this.state.cityList.find(
                                            (city) => city.city_name == value,
                                          ),
                                        },
                                        async () => {
                                          let baseUrl = ``;
                                          axios
                                            .get(
                                              `${baseUrl}/api/get-zone-list/${this.state.cityObject.city_id}`,
                                              {
                                                headers: {
                                                  "Content-Type":
                                                    "application/json",
                                                  Authorization: `Bearer ${this.state.access_token}`,
                                                },
                                              },
                                            )
                                            .then((response) => {
                                              console.log(response);
                                              this.setState({
                                                areaList:
                                                  response.data.data.data,
                                              });
                                            })
                                            .catch((error) => {
                                              console.log(error);
                                            });
                                        },
                                      );
                                    }}
                                    style={{ fontSize: ".8rem" }}
                                    value={this.state.city}
                                    required
                                  >
                                    <option value="">Select City</option>
                                    {this.state.cityList.map((city) => {
                                      return (
                                        <option value={city.city_name}>
                                          {city.city_name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                                <div
                                  // className="form-group"
                                  style={{ minWidth: "100%", marginTop: 15 }}
                                >
                                  <div style={{ fontWeight: "bold" }}>
                                    Select Zone
                                  </div>
                                  <select
                                    title=""
                                    name="zone"
                                    className="custom-select"
                                    aria-required="true"
                                    aria-invalid="false"
                                    onChange={(e) => {
                                      const { name, value } = e.target;
                                      this.setState({
                                        [name]: value,
                                        zoneObject: this.state.areaList.find(
                                          (area) => area.zone_name == value,
                                        ),
                                      });
                                    }}
                                    style={{ fontSize: ".8rem" }}
                                    value={this.state.zone}
                                    required
                                  >
                                    {this.state.cityObject &&
                                    this.state.areaList.length > 0 ? (
                                      <>
                                        <option value="">Select Area</option>
                                        {this.state.areaList.map((area) => {
                                          return (
                                            <option value={area.zone_name}>
                                              {area.zone_name}
                                            </option>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <option value="">
                                        Select City first
                                      </option>
                                    )}
                                  </select>
                                </div>
                              </>
                            )}

                            <div
                              // className="form-group"
                              style={{ minWidth: "100%", marginTop: 15 }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                Write Delivery Instruction
                              </div>
                              <textarea
                                name="note"
                                value={this.state.note}
                                style={{
                                  width: "100%",
                                  height: 200,
                                  border: "1px solid gainsboro",
                                  borderRadius: 5,
                                  textAlign: "left",
                                  marginTop: 5,
                                  padding: 10,
                                }}
                                type="search"
                                placeholder="Wrtie delivery instruction to courier partner"
                                onChange={(e) => {
                                  this.setState({
                                    note: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      <div
                        style={{
                          marginTop: 30,
                          fontWeight: "bold",
                          marginBottom: 6,
                        }}
                      >
                        Courier Information
                      </div>
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Consignment Id:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.consignment_id}
                            </span>
                          </div>
                        )}{" "}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Delivery Fee:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.delivery_fee}Tk
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            City (for pathao booking):{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.city.city_name}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Zone (for pathao booking):{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.zone.zone_name}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Parcel weight (for pathao booking):{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.weight}kg
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.consignment && (
                          <div style={{ marginTop: 5 }}>
                            Created At:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {new Date(
                                orderObj.courier.consignment.created_at,
                              ).toLocaleString("en-BD", {
                                timeZone: "Asia/Dhaka",
                              })}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.consignment && (
                          <div style={{ marginTop: 5 }}>
                            Consignment id:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj &&
                                orderObj.courier.consignment.consignment_id}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.consignment && (
                          <div style={{ marginTop: 5 }}>
                            Tracking Code:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj &&
                                orderObj.courier.consignment.tracking_code}
                            </span>
                          </div>
                        )}
                      <div style={{ marginTop: 5 }}>
                        Invoice:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {orderObj && orderObj.id}
                        </span>
                      </div>
                      {orderObj && (
                        <div className="wrap-info">
                          {orderObj.currentUser ? (
                            <ul>
                              <li style={{ marginTop: 5 }}>
                                Name :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.fullName
                                  }
                                </span>
                              </li>{" "}
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Mobile No :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.mobileNo
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Address :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {
                                    orderObj.currentUser?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.address
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                District :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.district
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Division :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.division
                                  }
                                </span>
                              </li>
                              <br />
                              {this.state.courier == "Pathao" && (
                                <>
                                  <li style={{ marginTop: 5 }}>
                                    Parcel Weight:
                                    <span style={{ fontWeight: "bold" }}>
                                      {this.state.weight
                                        ? this.state.weight
                                        : 1}
                                      kg
                                    </span>
                                  </li>
                                  <br />
                                  <li style={{ marginTop: 5 }}>
                                    Selected City (for Pathao) :
                                    <span style={{ fontWeight: "bold" }}>
                                      {this.state.cityObject &&
                                        this.state.cityObject.city_name}
                                    </span>
                                  </li>
                                  <br />
                                  <li style={{ marginTop: 5 }}>
                                    Selected Zone (for Pathao) :
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      {this.state.zoneObject &&
                                        this.state.zoneObject.zone_name}
                                    </span>
                                  </li>
                                </>
                              )}
                            </ul>
                          ) : (
                            <ul>
                              <li style={{ marginTop: 5 }}>
                                Name :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.fullName
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Mobile No :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.mobileNo
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Address :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {
                                    orderObj.guest?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.address
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                District :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.district
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Division :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest?.address?.find(
                                      (address) => address.defaultShipping,
                                    )?.division
                                  }
                                </span>
                              </li>{" "}
                              <br />
                              {this.state.courier == "Pathao" && (
                                <>
                                  {!orderObj.courier && (
                                    <li style={{ marginTop: 5 }}>
                                      Parcel Weight:
                                      <span style={{ fontWeight: "bold" }}>
                                        {this.state.weight && this.state.weight}
                                        kg
                                      </span>
                                    </li>
                                  )}

                                  {!orderObj.courier && (
                                    <>
                                      {" "}
                                      <br />
                                      <li style={{ marginTop: 5 }}>
                                        Selected City (for Pathao) :
                                        <span style={{ fontWeight: "bold" }}>
                                          {this.state.cityObject &&
                                            this.state.cityObject.city_name}
                                        </span>
                                      </li>
                                    </>
                                  )}

                                  {!orderObj.courier && (
                                    <>
                                      <br />
                                      <li style={{ marginTop: 5 }}>
                                        Selected Zone (for Pathao) :
                                        <span style={{ fontWeight: "bold" }}>
                                          {" "}
                                          {this.state.zoneObject &&
                                            this.state.zoneObject.zone_name}
                                        </span>
                                      </li>
                                    </>
                                  )}
                                </>
                              )}
                            </ul>
                          )}
                        </div>
                      )}
                      <div style={{ marginTop: 5 }}>
                        COD Amount:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {amountPayable - totalPaid}
                          Tk
                        </span>
                      </div>
                      <div style={{ marginTop: 5 }}>
                        Note: <br />
                        <span
                          style={{
                            fontSize: 12,
                            marginTop: 2,
                            fontWeight: "bold",
                          }}
                        >
                          {!orderObj.courier
                            ? this.state.note
                            : orderObj.courier.note}
                        </span>
                      </div>
                    </div>
                  </div>
                  {orderObj &&
                    orderObj.courier &&
                    orderObj.courier.consignment && (
                      <div style={{ marginLeft: 12 }}>
                        <div style={{ fontWeight: "bold" }}>
                          Tracking Details
                        </div>
                        <div style={{ marginTop: 5 }}>
                          Delivery Status:{" "}
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "white",
                              background: "#00B795",
                              borderRadius: 5,
                              padding: "0px 10px",
                            }}
                          >
                            {orderObj.deliveryStatus}
                          </span>
                        </div>
                        <div style={{ marginTop: 5 }}>
                          Status Details:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {orderObj.deliveryStatusDescription}
                          </span>
                        </div>
                      </div>
                    )}
                  {orderObj && orderObj.courier && orderObj.courier.pathao && (
                    <div style={{ marginLeft: 12 }}>
                      <div style={{ fontWeight: "bold" }}>Tracking Details</div>
                      <div style={{ marginTop: 5 }}>
                        Delivery Status:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "white",
                            background: "#00B795",
                            borderRadius: 5,
                            padding: "0px 10px",
                          }}
                        >
                          {orderObj.deliveryStatus}
                        </span>
                      </div>
                      <div style={{ marginTop: 5 }}>
                        Status Details:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {orderObj.deliveryStatusDescription}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {orderObj && !orderObj.courier && (
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn "
                    data-dismiss="modal"
                    style={{
                      background: "linear-gradient(135deg, #DC2626, #EF4444)",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                      fontWeight: "lighter",
                    }}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      background: "linear-gradient(135deg, #15803D, #22C55E)",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                      fontWeight: "lighter",
                    }}
                    onClick={() => {
                      this.handleCourier(amountPayable - totalPaid);
                    }}
                  >
                    Yes
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="paymentModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto", maxWidth: 750, width: "100%" }}
          >
            <div
              className="modal-content"
              style={{
                top: 10,
                width: "100%",
                margin: "auto",
                borderRadius: 14,
                overflow: "hidden",
                border: "none",
                boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  background: "linear-gradient(135deg, #FB9404, #FDB750)",
                  padding: "18px 24px",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <div
                    className="modal-title"
                    style={{ fontWeight: 800, fontSize: 18, color: "white" }}
                    id="exampleModalLabel"
                  >
                    Receive Payment
                  </div>
                  {orderObj && (
                    <div
                      style={{
                        color: "rgba(255,255,255,0.85)",
                        fontSize: 12,
                        fontWeight: 600,
                        marginTop: 2,
                      }}
                    >
                      Order #{orderObj.id}
                    </div>
                  )}
                </div>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                  style={{
                    background: "rgba(255,255,255,0.22)",
                    border: "none",
                    borderRadius: "50%",
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                  }}
                >
                  <span
                    aria-hidden="true"
                    style={{ color: "white", fontSize: 20, lineHeight: 1 }}
                  >
                    &times;
                  </span>
                </button>
              </div>
              {orderObj && (
                <>
                  <div
                    style={{
                      padding: "16px 24px",
                      background:
                        amountPayable - totalPaid <= 0
                          ? "linear-gradient(135deg, #ECFDF5, #D1FAE5)"
                          : "linear-gradient(135deg, #FEF2F2, #FFF7ED)",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: 8,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            letterSpacing: 0.8,
                            textTransform: "uppercase",
                            color:
                              amountPayable - totalPaid <= 0
                                ? "#059669"
                                : "#DC2626",
                          }}
                        >
                          {amountPayable - totalPaid <= 0
                            ? "Paid in Full"
                            : "Amount Due"}
                        </div>
                        <div
                          style={{
                            fontSize: 30,
                            fontWeight: 800,
                            color:
                              amountPayable - totalPaid <= 0
                                ? "#059669"
                                : "#DC2626",
                            marginTop: 2,
                            lineHeight: 1,
                          }}
                        >
                          ৳{" "}
                          {amountPayable - totalPaid <= 0
                            ? amountPayable
                            : amountPayable - totalPaid}
                        </div>
                      </div>
                      <div
                        style={{ fontSize: 12, color: "#666", fontWeight: 600 }}
                      >
                        ৳ {totalPaid} paid of ৳ {amountPayable}
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: 10,
                        height: 6,
                        borderRadius: 3,
                        background: "#e5e7eb",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          width: `${
                            amountPayable > 0
                              ? Math.min(
                                  100,
                                  (totalPaid / amountPayable) * 100,
                                )
                              : 100
                          }%`,
                          background:
                            amountPayable - totalPaid <= 0
                              ? "#10B981"
                              : "linear-gradient(90deg, #FB9404, #F59E0B)",
                          borderRadius: 3,
                        }}
                      />
                    </div>
                  </div>

                  <div className="modal-body">
                   <div className="pm-shell">
                    <div
                      style={{
                        background: "#f8f9fa",
                        border: "1px solid #e5e7eb",
                        borderRadius: 10,
                        padding: 16,
                        marginBottom: 16,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#475569",
                          textTransform: "uppercase",
                          letterSpacing: 0.8,
                          marginBottom: 12,
                        }}
                      >
                        Order Information
                      </div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          columnGap: 20,
                          rowGap: 12,
                        }}
                      >
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Order Id
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            #{orderObj.id}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Ordered at
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            {new Date(
                              Number(orderObj.date),
                            ).toLocaleDateString()}{" "}
                            {new Date(
                              Number(orderObj.date),
                            ).toLocaleTimeString()}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Order Status
                          </div>
                          <span
                            style={{
                              display: "inline-block",
                              marginTop: 2,
                              color: "white",
                              padding: "3px 7px",
                              borderRadius: 5,
                              background: orderObj
                                ? orderObj.orderStatus == "Processing"
                                  ? "linear-gradient(135deg, #3730A3, #6D28D9)"
                                  : orderObj.orderStatus == "Confirmed"
                                    ? "linear-gradient(135deg, #F59E0B, #FB923C)"
                                    : orderObj.orderStatus == "Packing"
                                      ? "linear-gradient(135deg, #D97706, #F97316)"
                                      : orderObj.orderStatus == "On the way"
                                        ? "linear-gradient(135deg, #059669, #10B981)"
                                        : orderObj.orderStatus == "Delivered"
                                          ? "linear-gradient(135deg, #059669, #10B981)"
                                          : orderObj.orderStatus == "Cancelled"
                                            ? "linear-gradient(135deg, #DC2626, #EF4444)"
                                            : "linear-gradient(135deg, #94A3B8, #CBD5E1)"
                                : "linear-gradient(135deg, #94A3B8, #CBD5E1)",
                              textAlign: "center",
                              fontSize: 12,
                            }}
                          >
                            {orderObj.orderStatus}
                          </span>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Subtotal
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            ৳{orderObj.subTotal}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Delivery Charge
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            ৳ {orderObj.deliveryCharge || "0"}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Discount Applied
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            ৳ {orderObj.discountApplied || "0"}
                          </div>
                        </div>
                        {orderObj.couponApplied && (
                          <div>
                            <div
                              style={{
                                fontSize: 11,
                                color: "#888",
                                fontWeight: 600,
                              }}
                            >
                              Coupon Applied{" "}
                              <span
                                style={{ color: "#7C3AED", fontWeight: "bold" }}
                              >
                                ({orderObj.couponApplied.name})
                              </span>
                            </div>
                            <div style={{ fontWeight: 700, fontSize: 13 }}>
                              ৳ {orderObj.couponApplied.discount || 0}
                            </div>
                          </div>
                        )}
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Amount Payable
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            ৳{" "}
                            {orderObj.subTotal +
                              orderObj.deliveryCharge -
                              orderObj.discountApplied -
                              (orderObj.couponApplied
                                ? orderObj.couponApplied.discount
                                : 0)}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Final Discount
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            -৳{" "}
                            {orderObj.finalDiscount
                              ? orderObj.finalDiscount
                              : 0}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Amount Payable{" "}
                            <span style={{ fontSize: 10 }}>(after discount)</span>
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            ৳{" "}
                            {orderObj.subTotal +
                              orderObj.deliveryCharge -
                              orderObj.discountApplied -
                              (orderObj.couponApplied
                                ? orderObj.couponApplied.discount
                                : 0) -
                              (orderObj.finalDiscount
                                ? orderObj.finalDiscount
                                : 0)}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Total Paid
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            ৳ {totalPaid}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Total Due
                          </div>
                          <div
                            style={{ fontWeight: 700, fontSize: 13, color: "red" }}
                          >
                            ৳ {amountPayable - totalPaid}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontSize: 11, color: "#888", fontWeight: 600 }}
                          >
                            Courier Charge
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            ৳{" "}
                            {orderObj.courierCharge
                              ? orderObj.courierCharge
                              : 0}
                          </div>
                        </div>
                      </div>
                    </div>

                    {this.props.currentAdmin &&
                    (this.props.currentAdmin.status == "Admin" ||
                      this.props.currentAdmin.status == "Accounts") ? (
                      <form onSubmit={this.handleSubmitMerged}>
                        {/* Payment section */}
                        <div
                          style={{
                            background: "#f8f9ff",
                            border: "1px solid #e0e0f0",
                            borderRadius: 10,
                            padding: 16,
                            marginBottom: 16,
                          }}
                        >
                          <div
                            style={{
                              fontSize: 11,
                              fontWeight: 700,
                              color: "#6D28D9",
                              textTransform: "uppercase",
                              letterSpacing: 0.8,
                              marginBottom: 12,
                            }}
                          >
                            Payment Entry{" "}
                            <span
                              style={{
                                fontWeight: 400,
                                color: "#888",
                                textTransform: "none",
                                letterSpacing: 0,
                              }}
                            >
                              — required only if paid amount is entered
                            </span>
                          </div>
                          <div className="form-row mb-2">
                            <div className="col-12 col-sm-4 mb-2 mb-sm-0">
                              <label
                                style={{
                                  marginBottom: 4,
                                  fontSize: 12,
                                  fontWeight: "bold",
                                  display: "block",
                                }}
                              >
                                Paid Amount
                              </label>
                              <input
                                type="number"
                                name="amount"
                                className="form-control"
                                placeholder="Amount"
                                style={{ fontSize: "0.875rem", height: 38 }}
                                onChange={this.handleChange}
                                value={this.state.amount}
                              />
                            </div>
                            <div className="col-12 col-sm-4 mb-2 mb-sm-0">
                              <label
                                style={{
                                  marginBottom: 4,
                                  fontSize: 12,
                                  fontWeight: "bold",
                                  display: "block",
                                }}
                              >
                                Payment Method
                              </label>
                              <select
                                name="method"
                                className="form-control"
                                onChange={this.handleChange}
                                style={{ fontSize: "0.875rem", height: 38 }}
                                value={this.state.method}
                              >
                                <option value="">Select Method</option>
                                <option value="Cash">Cash</option>
                                <option value="Bkash">Bkash</option>
                                <option value="Nagad">Nagad</option>
                                <option value="Rocket">Rocket</option>
                                <option value="Eastern Bank">
                                  Eastern Bank
                                </option>
                                <option value="Courier (COD)">
                                  Courier (COD)
                                </option>
                              </select>
                            </div>
                            <div className="col-12 col-sm-4">
                              <label
                                style={{
                                  marginBottom: 4,
                                  fontSize: 12,
                                  fontWeight: "bold",
                                  display: "block",
                                }}
                              >
                                Payment Status
                              </label>
                              <select
                                name="paymentStatus"
                                className="form-control"
                                onChange={this.handleChange}
                                style={{ fontSize: "0.875rem", height: 38 }}
                                value={this.state.paymentStatus}
                              >
                                <option value="">Select Status</option>
                                <option value="Partially Paid">
                                  Partially Paid
                                </option>
                                <option value="Paid">Full Paid</option>
                              </select>
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="col">
                              <label
                                style={{
                                  marginBottom: 4,
                                  fontSize: 12,
                                  fontWeight: "bold",
                                  display: "block",
                                }}
                              >
                                Transaction ID
                              </label>
                              <input
                                type="text"
                                name="transactionId"
                                className="form-control"
                                placeholder="Enter transaction ID"
                                style={{ fontSize: "0.875rem", height: 38 }}
                                onChange={this.handleChange}
                                value={this.state.transactionId}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Courier charge section */}
                        <div
                          style={{
                            background: "#f8fff8",
                            border: "1px solid #d0ead0",
                            borderRadius: 10,
                            padding: 16,
                            marginBottom: 16,
                          }}
                        >
                          <div
                            style={{
                              fontSize: 11,
                              fontWeight: 700,
                              color: "#059669",
                              textTransform: "uppercase",
                              letterSpacing: 0.8,
                              marginBottom: 12,
                            }}
                          >
                            Courier Charge{" "}
                            <span
                              style={{
                                fontWeight: 400,
                                color: "#888",
                                textTransform: "none",
                                letterSpacing: 0,
                              }}
                            >
                              — optional, can be entered independently
                            </span>
                          </div>
                          <div className="form-row">
                            <div className="col-12">
                              <label
                                style={{
                                  marginBottom: 4,
                                  fontSize: 12,
                                  fontWeight: "bold",
                                  display: "block",
                                }}
                              >
                                Courier Charge
                              </label>
                              <input
                                type="number"
                                name="courierCharge"
                                className="form-control"
                                placeholder="Enter amount"
                                style={{ fontSize: "0.875rem", height: 38 }}
                                onChange={this.handleChange}
                                value={this.state.courierCharge}
                              />
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: 16,
                          }}
                        >
                          {this.state.loader ? (
                            <div
                              style={{
                                background:
                                  "linear-gradient(135deg, #4F46E5, #7C3AED)",
                                color: "white",
                                minWidth: 150,
                                padding: "10px 20px",
                                borderRadius: 8,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 8,
                                fontSize: 13,
                                fontWeight: 600,
                              }}
                            >
                              <ClipLoader size={16} color="white" loading />
                              Saving…
                            </div>
                          ) : (
                            <button
                              type="submit"
                              className="btn"
                              style={{
                                background:
                                  "linear-gradient(135deg, #4F46E5, #7C3AED)",
                                color: "white",
                                minWidth: 150,
                                padding: "10px 20px",
                                borderRadius: 8,
                                fontWeight: 700,
                                fontSize: 13,
                                letterSpacing: 0.5,
                              }}
                            >
                              Save &amp; Update &rsaquo;
                            </button>
                          )}
                        </div>
                      </form>
                    ) : null}

                    {orderObj.payments && orderObj.payments.length > 0 && (
                      <div
                        style={{
                          background: "#f8fbff",
                          border: "1px solid #dbeafe",
                          borderRadius: 10,
                          padding: 16,
                        }}
                      >
                        <div
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#0F766E",
                            textTransform: "uppercase",
                            letterSpacing: 0.8,
                            marginBottom: 12,
                          }}
                        >
                          Previous Payments
                        </div>
                        <div style={{ overflowX: "auto" }}>
                          <table
                            className="table table-bordered table-striped table-hover"
                            style={{ width: "100%", marginBottom: 0 }}
                          >
                            <thead
                              style={{
                                background:
                                  "linear-gradient(135deg, #0F766E, #0EA5E9)",
                                color: "white",
                              }}
                            >
                              <tr>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Date
                                </td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Method
                                </td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Transaction ID
                                </td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Amount
                                </td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Approved by
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {orderObj.payments.map((payment) => (
                                <tr>
                                  <td>{payment.date}</td>
                                  <td>{payment.method}</td>
                                  <td>{payment.transactionId}</td>
                                  <td>{payment.amount}Tk</td>
                                  <td>{payment.receivedBy}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                   </div>
                  </div>
                </>
              )}

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn"
                  data-dismiss="modal"
                  id="close-button-for-payment-modal"
                  style={{
                    background: "linear-gradient(135deg, #15803D, #22C55E)",
                    color: "white",
                    padding: "8px 20px",
                    borderRadius: 8,
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    this.setState({
                      orderObj: null,
                    });
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="detailInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{
              margin: "auto",
              minWidth: "60%",
              maxHeight: "80%",
              overflowY: "scroll",
            }}
          >
            <div className="modal-content" style={{ top: 10, margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Order Id: {orderObj && orderObj.id}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}></div>
                <div
                  className="row"
                  style={{
                    marginBottom: 10,
                    borderBottom: "1px solid gainsboro",
                  }}
                >
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Order Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Order Id:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        #{orderObj && orderObj.id}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Ordered at:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        {orderObj &&
                          new Date(Number(orderObj.date)).toLocaleDateString()}
                        {"  "}
                        {orderObj &&
                          new Date(Number(orderObj.date)).toLocaleTimeString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Order Status:{" "}
                      <span
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                          color: "white",
                          padding: "3px 7px",
                          borderRadius: 5,
                          background: orderObj
                            ? orderObj.orderStatus == "Processing"
                              ? "linear-gradient(135deg, #3730A3, #6D28D9)"
                              : orderObj.orderStatus == "Confirmed"
                                ? "linear-gradient(135deg, #F59E0B, #FB923C)"
                                : orderObj.orderStatus == "Packing"
                                  ? "linear-gradient(135deg, #D97706, #F97316)"
                                  : orderObj.orderStatus == "On the way"
                                    ? "linear-gradient(135deg, #059669, #10B981)"
                                    : orderObj.orderStatus == "Delivered"
                                      ? "linear-gradient(135deg, #059669, #10B981)"
                                      : orderObj.orderStatus == "Cancelled"
                                        ? "linear-gradient(135deg, #DC2626, #EF4444)"
                                        : "linear-gradient(135deg, #94A3B8, #CBD5E1)"
                            : "linear-gradient(135deg, #94A3B8, #CBD5E1)",
                          textAlign: "center",
                          fontSize: 12,
                        }}
                      >
                        {orderObj && orderObj.orderStatus}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Subtotal:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳{orderObj && orderObj.subTotal}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Delivery Charge:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳ {(orderObj && orderObj.deliveryCharge) || "0"}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Discount Applied:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳ {(orderObj && orderObj.discountApplied) || "0"}
                      </span>
                    </div>
                    {orderObj && orderObj.couponApplied && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Coupon Applied{" "}
                        <span
                          style={{
                            color: "#7C3AED",
                            fontWeight: "bold",
                            fontSize: 12,
                          }}
                        >
                          {" "}
                          ({orderObj.couponApplied.name})
                        </span>
                        :{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {" "}
                          ৳ {(orderObj && orderObj.couponApplied.discount) || 0}
                        </span>
                      </div>
                    )}
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Amount Payable:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        ৳{" "}
                        {orderObj &&
                          orderObj.subTotal +
                            orderObj.deliveryCharge -
                            orderObj.discountApplied -
                            (orderObj.couponApplied
                              ? orderObj.couponApplied.discount
                              : 0)}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Final Discount:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        ৳{" "}
                        {orderObj && orderObj.finalDiscount
                          ? orderObj.finalDiscount
                          : 0}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Amount Payable{" "}
                      <span style={{ fontSize: 11 }}>(after discount)</span>
                      <span style={{ fontWeight: "bold" }}>
                        ৳{" "}
                        {orderObj &&
                          orderObj.subTotal +
                            orderObj.deliveryCharge -
                            orderObj.discountApplied -
                            (orderObj.couponApplied
                              ? orderObj.couponApplied.discount
                              : 0) -
                            (orderObj.finalDiscount
                              ? orderObj.finalDiscount
                              : 0)}
                      </span>
                    </div>
                    {orderObj && orderObj.cancelNote && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Cancellation Note:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: 13,
                            color: "gray",
                          }}
                        >
                          {orderObj.cancelNote}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Schedule Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Order Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          new Date(Number(orderObj.date)).toLocaleDateString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Confirmed Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          orderObj.confirmedDate &&
                          new Date(
                            Number(orderObj.confirmedDate),
                          ).toLocaleDateString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Packing Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          orderObj.packingDate &&
                          new Date(
                            Number(orderObj.packingDate),
                          ).toLocaleDateString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Delivered Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          orderObj.deliveredDate &&
                          new Date(
                            Number(orderObj.deliveredDate),
                          ).toLocaleDateString()}
                      </span>
                    </div>
                    {orderObj && orderObj.cancelledDate && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Cancelled Date:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {orderObj &&
                            orderObj.cancelledDate &&
                            new Date(
                              Number(orderObj.cancelledDate),
                            ).toLocaleDateString()}
                        </span>
                      </div>
                    )}
                    {orderObj && orderObj.orderNote && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                          marginTop: 30,
                        }}
                      >
                        Order note:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {orderObj && orderObj.orderNote}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Customer Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Id:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.uid}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Name:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.displayName}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Email:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.email}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Mobile No:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.mobielNumber}
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Delivery Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Name :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.fullName}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Mobile :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.mobileNo}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Address :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.address}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      District :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.district}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Division :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.division}
                      </span>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 30 }}></div>
                <table className="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <td style={{ fontWeight: "bold" }}>Product Image</td>
                      <td style={{ fontWeight: "bold" }}>Product Name</td>
                      <td style={{ fontWeight: "bold" }}>Product Price</td>
                      <td style={{ fontWeight: "bold" }}>Total Quantity</td>
                      <td style={{ fontWeight: "bold" }}>
                        Available Stock <br />{" "}
                        <span style={{ fontSize: 12, color: "gray" }}>
                          at the time of order
                        </span>
                      </td>
                      <td style={{ fontWeight: "bold" }}>Total Price</td>
                    </tr>
                  </thead>
                  <tbody>
                    {orderObj &&
                      orderObj.orders.map((order) => (
                        <tr key={order.id}>
                          <td>
                            <img
                              style={{ height: 70, width: 70 }}
                              src={
                                order.selectedVariation &&
                                order.selectedVariation?.id &&
                                order.selectedVariation.pictures &&
                                order.selectedVariation.pictures.length > 0
                                  ? order.selectedVariation.pictures[0]
                                  : order.product.pictures[0]
                              }
                            />
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {order.product.name.slice(0, 50)}...
                              </div>
                              {order.product.selectedCategories &&
                                order.product.selectedCategories.length > 0 &&
                                order.product.selectedCategories
                                  .slice(0, 2)
                                  .map((cat, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        fontSize: 14,
                                        color: "#444",
                                      }}
                                    >
                                      {cat.name}
                                    </div>
                                  ))}

                              <div style={{ marginTop: 6 }}>
                                {order.selectedVariation &&
                                  order.selectedVariation?.id &&
                                  order.selectedVariation.combination.map(
                                    (comb, index) => (
                                      <div key={index}>
                                        {order.product.savedAttributes.find(
                                          (attr) => attr.id == comb.parentId,
                                        )
                                          ? order.product.savedAttributes.find(
                                              (attr) =>
                                                attr.id == comb.parentId,
                                            ).name
                                          : ""}
                                        : {comb.name}
                                      </div>
                                    ),
                                  )}
                              </div>
                              <div>
                                Total:৳ {this.singleProductTotal(order)} (
                                {order.quantity}pc)
                              </div>
                            </div>
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-around",
                              }}
                            >
                              {" "}
                              <div
                                style={{
                                  fontSize: 13,
                                  textDecorationLine: "line-through",
                                  color: "gray",
                                }}
                              >
                                {this.getPrice3(order)}{" "}
                              </div>
                              <div
                                style={{
                                  color: "black",
                                  fontSize: 13,
                                  fontWeight: "bold",
                                }}
                              >
                                ৳ {this.getPrice2(order)}
                              </div>
                            </div>
                          </td>
                          <td>{order.quantity}Pc</td>
                          <td>
                            {order.selectedVariation &&
                            order.selectedVariation.inventory
                              ? order.selectedVariation.inventory
                              : order.product.inventory}
                            Pc
                          </td>

                          <td style={{ fontWeight: "bold" }}>
                            ৳ {this.singleProductTotal(order)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn"
                  data-dismiss="modal"
                  style={{
                    background: "linear-gradient(135deg, #4F46E5, #7C3AED)",
                    color: "white",
                    padding: "8px 22px",
                    borderRadius: 8,
                    fontWeight: 600,
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {hasMore && this.state.loading5 && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 30,
            }}
          >
            {" "}
            <ClipLoader color="#ff8084" size={60} />
          </div>
        )}

        <ReactToPrint
          ref={(el) => (this.reactToPrintTrigger = el)} // <-- ref
          content={() => this.componentRef}
        />

        <div style={{ display: "none" }}>
          <div
            ref={(el) => (this.componentRef = el)}
            className="print-area-2"
            style={{ background: "white" }}
          >
            {(() => {
              const addr = this.getDeliveryAddress(orderObj);
              const addrText = [
                addr?.fullName,
                addr?.mobileNo,
                addr?.address,
                addr?.district,
                addr?.division,
              ]
                .filter(Boolean)
                .join(" ");
              const addrFs =
                addrText.length > 130 ? 9 : addrText.length > 80 ? 11 : 13;
              const cod = this.getTotalDue(orderObj);
              const codFs = String(cod || "").length > 8 ? 14 : 18;
              return (
                <div>
                  {/* Logo */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      className="blur-up lazyloaded"
                      src={logo}
                      alt=""
                      style={{ maxWidth: "40%" }}
                    />
                  </div>
                  {/* Company address */}
                  <div style={{ textAlign: "center", fontSize: 11 }}>
                    44/45, 5th floor,Bikrampur Housing, New
                    Alibohar,Postogola,Dhaka-1204
                  </div>
                  {/* CN# */}
                  <div
                    style={{
                      border: "1px solid black",
                      borderLeft: "none",
                      borderRight: "none",
                      padding: "5px 7px",
                      fontWeight: "bold",
                      fontSize: 15,
                      textAlign: "center",
                      marginTop: 5,
                    }}
                  >
                    CN#
                    {orderObj &&
                      orderObj.courier &&
                      orderObj.courier.consignment &&
                      orderObj.courier.consignment.consignment_id}
                  </div>
                  {/* SHIP TO box — fixed height, clips overflow */}
                  <div
                    style={{
                      border: "1px solid black",
                      borderBottom: "none",
                      padding: "6px 8px",
                      marginTop: 4,
                      height: 98,
                      overflow: "hidden",
                      boxSizing: "border-box",
                      wordBreak: "break-word",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: 12,
                        marginBottom: 2,
                      }}
                    >
                      SHIP TO,
                    </div>
                    <div style={{ fontSize: addrFs }}>
                      Customer: {addr?.fullName}
                    </div>
                    <div style={{ fontSize: addrFs }}>
                      Mobile: {addr?.mobileNo}
                    </div>
                    <div style={{ fontSize: addrFs, lineHeight: 1.3 }}>
                      Address: {addr?.address}
                    </div>
                    <div style={{ fontSize: addrFs }}>
                      {addr?.district},{addr?.division}
                    </div>
                  </div>
                  {/* COD box */}
                  <div
                    style={{
                      border: "1px solid black",
                      padding: "6px 8px",
                      display: "flex",
                      alignItems: "center",
                      minHeight: 36,
                      boxSizing: "border-box",
                    }}
                  >
                    <div style={{ fontWeight: "bold", fontSize: codFs }}>
                      COD: ৳ {cod}
                    </div>
                  </div>
                  {/* Footer */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: 5,
                      left: 0,
                      padding: 10,
                      width: "100%",
                      background: "white",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold", fontSize: 10 }}>
                        Thank you for staying with us
                      </div>
                      <div style={{ fontWeight: "bold", fontSize: 10 }}>
                        zapai.com.bd
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: 40,
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        marginTop: 5,
                        fontSize: 16,
                        background: "white",
                      }}
                    >
                      <div>
                        <Barcode
                          value={orderObj?.id || "DEFAULTID"}
                          width={1.5}
                          height={30}
                          displayValue={true}
                          margin={0}
                          format="CODE128"
                          fontSize={15}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admins.currentAdmin,
    orders: state.orders.orders,
    hasMore: state.orders.hasMore,
    lastVisible: state.orders.lastVisible,
  };
};

export default connect(mapStateToProps, {
  getOrdersListRedux,
  updateOrderRedux,
  uploadCashInRedux,
  uploadTransactionRedux,
  updateSingleProductRedux,
  uploadExpenseRedux,
  bulkUpdateOrderStatusRedux,
})(Orders);
